<template>
  <div class="ml-6 mr-6 mt-2" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''">
    <v-alert v-if="alert" class="mb-3" border="top" :color="colorAlert" dark>
      {{ message }}
    </v-alert>

    <v-layout
      :class="{
        'd-flex ma-0 pa-0 ml-1 justify-center': (showDateStart == '' && showDateEnd == '') || (showDateStart != '' && showDateEnd != '' && isShowDate == false),
        'd-flex ma-0 pa-0 ml-1': showDateStart != '' && showDateEnd != '' && isShowDate == true
      }"
      :style="navbarWithName ? 'margin-left: 10px !important;' : ''"
      row
      wrap
    >
      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="topicSentiment"
          item-text="TOPIC"
          item-value="SEQ_ID"
          v-model="selectedTopic"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Topic"
          no-data-text="No topic available"
          dense
          outlined
          rounded
          @change="statusFilter = '', parameterProsesTopic()"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
        <v-select
          :items="topicKeywordSentiment"
          v-model="selectedKeyword"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Keyword"
          no-data-text="No keyword available"
          dense
          outlined
          rounded
          @change="parameterProsesKeyword"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="periodeBerita"
          item-text="name"
          item-value="value"
          v-model="selectedPeriode"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Periode"
          dense
          outlined
          rounded
          @change="parameterProsesPeriode"
        ></v-select>
      </v-col>

      <v-col
        v-if="showDateStart != '' && showDateEnd != ''"
        class="d-flex ma-0 pa-0 mx-3"
        cols="12"
        sm="3"
      >
        <v-card style="border-radius: 30px; width: 100%;" height="40" outlined>
          <v-card-text class="pa-2 px-4">
            <v-icon>mdi-calendar</v-icon>
            <span class="mt-2 ml-1">
              {{ showDateStart[1] + " " + showDateStart[0] + " " + showDateStart[2] }} - {{ showDateEnd[1] + " " + showDateEnd[0] + " " + showDateEnd[2] }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        :class="{
          'd-flex ma-0 pa-0 ml-3': (showDateStart == '' && showDateEnd == '') || (showDateStart != '' && showDateEnd != '' && isShowDate == false),
          'd-flex ma-0 pa-0': showDateStart != '' && showDateEnd != '' && isShowDate == true
        }"
        cols="12"
        sm="1"
      >
        <v-btn
          color="var(--color-theme-secondary)"
          style="max-width: 100%;"
          height="40"
          dense
          dark
          rounded
          block
          @click="isSearch = true, loadSearchTrendingTopic()"
        >
          <v-icon>mdi-magnify</v-icon>
          Search
        </v-btn>
      </v-col>

      <v-col
        class="d-flex ma-0 pa-0 ml-3"
        cols="12"
        sm="1"
      >
        <v-btn
          v-if="isColorThemeSetneg"
          color="var(--color-theme)"
          style="max-width: 100%;"
          height="40"
          outlined
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>

        <v-btn
          v-else
          class="white--text"
          height="40"
          color="#a80202"
          variant="outlined"
          style="max-width: 100%;"
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>
      </v-col>

      <v-col
        :class="{
          'd-flex ma-0 pa-0 ml-3': (showDateStart == '' && showDateEnd == '') || (showDateStart != '' && showDateEnd != '' && isShowDate == false),
          'd-flex align-center ma-0 pa-0': showDateStart != '' && showDateEnd != '' && isShowDate == true
        }"
        cols="12"
        :sm="showDateStart != '' && showDateEnd != '' && isShowDate == true ? 'auto' : '1'"
        :style="showDateStart != '' && showDateEnd != '' && isShowDate == true ? 'flex: 1;' : ''"
      >
        <v-btn
          color="var(--color-theme)"
          style="max-width: 100%;"
          height="40"
          outlined
          rounded
          @click="isCapture = true, captureAll()"
        >
          <v-icon>mdi-content-cut</v-icon>
          Capture
        </v-btn>

        <div
          v-if="showDateStart != '' && showDateEnd != '' && isShowDate == true"
          class="grey--text text-caption d-flex align-center"
          style="font-size: 14px !important; white-space: nowrap; flex: 1; justify-content: flex-end;"
        >
          This analysis has been calculated on {{ lastCalculatedOn }}
        </div>
      </v-col>

      <v-col
        v-if="(showDateStart == '' && showDateEnd == '') || (showDateStart != '' && showDateEnd != '' && isShowDate == false)"
        cols="12"
        class="d-flex ma-0 pa-0 justify-end"
      >
        <div class="grey--text text-caption" style="font-size: 14px !important;">
          This analysis has been calculated on {{ lastCalculatedOn }}
        </div>
      </v-col>
    </v-layout>

    <div class="mb-8 d-flex justify-end">
      <v-btn
        class="d-flex align-center justify-space-between pa-0 px-2"
        :style="{
          position: 'fixed',
          bottom: '60px',
          right: '30px',
          'z-index': (dialogLoading || dialogSearchContext) ? 1 : 9999,
          'border-radius': '9999px'
        }"
        height="50"
        width="165"
        color="white"
        elevation="4"
        @click="insightAIassistant()"
      >
        <div
          class="d-flex align-center justify-center"
          :style="{ backgroundColor: 'var(--color-theme)', borderRadius: '50%', width: '36px', height: '36px' }"
        >
          <SparklesIcon class="w-4 h-4" style="color: white;" />
        </div>

        <div style="flex: 1; text-align: center;">
          <span style="text-transform: none; color: black; font-size: 14px;">
            Insights AI
          </span>
        </div>

        <v-icon
          :style="{
            'margin-top': dialogPageInsight ? '-3px' : '1px',
            transform: dialogPageInsight ? 'rotate(90deg)' : 'rotate(-90deg)',
            transition: 'transform 0.2s ease',
            color: 'black'
          }"
          size="18"
        >
          mdi-play
        </v-icon>
      </v-btn>
    </div>

    <v-layout row wrap>
      <v-flex lg4 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mx-5 mb-6 rounded-lg pa-4' : 'mx-4 mb-6 rounded-lg pa-4'" height="400px" flat>
          <div class="mt-2 ml-4 font-weight-medium" style="font-size: 22px;">
            Sentiment Analysis
          </div>
          <div class="ml-4 grey--text" style="font-size: 15px;">
            Public Sentiment Distribution
          </div>

          <div class="chart-wrapper">
            <apexchart
              :options="chartPie"
              :series="seriesDonut"
              class="mt-2"
              type="donut"
              width="370px"
              style="cursor: pointer"
              @dataPointSelection="filterBySentiment"
            ></apexchart>
          </div>
        </v-card>
      </v-flex>

      <v-flex lg4 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mr-5 mb-6 rounded-lg' : 'mr-4 mb-6 rounded-lg'" height="320px" flat>
          <div ref="tagCloudNewsCard">
            <div class="ml-7 pt-6 font-weight-medium" style="font-size: 22px;">
              Tag Cloud News
            </div>
            <div class="ml-7 mb-2 grey--text" style="font-size: 15px;">
              News Term Frequency
            </div>

            <v-flex lg12>
              <v-card height="320px" flat>
                <vue-wordcloud
                  v-if="loadingTagCloud == false"
                  :key="wordCloudKeyNews"
                  class="wordcloud-class"
                  :data="wordsNews"
                  nameKey="name"
                  valueKey="value"
                  font="Roboto"
                  spiral="rectangular"
                  :fontSize="fontSizeTagCloudNews"
                  :color="colorWordCloudNews"
                  :rotate="rotateTagCloud"
                  :wordPadding="4"
                  :wordClick="wordClickHandlerNews"
                />
              </v-card>
            </v-flex>
          </div>
        </v-card>
      </v-flex>

      <v-flex lg4 sm12 md12 xs12>
        <v-card
          :class="navbarWithName ? 'mr-2 mb-6 rounded-lg' : 'mr-2 mb-6 rounded-lg'"
          :style="$vuetify.breakpoint.mdAndDown ? 'margin-top: 82px;' : ''"
          height="320px"
          flat
        >
          <div ref="tagCloudSocialMediaCard">
            <div class="ml-7 pt-6 font-weight-medium" style="font-size: 22px;">
              Tag Cloud Social Media
            </div>
            <div class="ml-7 mb-2 grey--text" style="font-size: 15px;">
              Social Media Term Frequency
            </div>

            <v-flex lg12>
              <v-card height="320px" flat>
                <vue-wordcloud
                  v-if="loadingTagCloud == false"
                  :key="wordCloudKeySocialMedia"
                  class="wordcloud-class"
                  :data="wordsSocialMedia"
                  nameKey="name"
                  valueKey="value"
                  font="Roboto"
                  spiral="rectangular"
                  :fontSize="fontSizeTagCloudSocialMedia"
                  :color="colorWordCloudSocialMedia"
                  :rotate="rotateTagCloud"
                  :wordPadding="4"
                  :wordClick="wordClickHandlerSocmed"
                />
              </v-card>
            </v-flex>
          </div>
        </v-card>
      </v-flex>

      <v-flex lg6 sm12 md12 xs12>
        <v-card
          :class="navbarWithName ? 'mx-5 mb-6 rounded-lg pa-4' : 'mx-4 mb-6 rounded-lg pa-4'"
          :style="$vuetify.breakpoint.mdAndDown ? 'margin-top: 82px;' : ''"
          height="400px"
          flat
        >
          <div ref="topPersonCard">
            <div class="mt-2 ml-4 font-weight-medium" style="font-size: 22px;">
              Top Person
            </div>
            <div class="ml-4 mb-1 grey--text" style="font-size: 15px;">
              Frequently Mention Individuals
            </div>

            <apexchart
              :options="barChartPerson"
              :series="seriesBarPerson"
              type="bar"
              height="300"
              @click="clickChartBarPerson"
            ></apexchart>
          </div>
        </v-card>
      </v-flex>

      <v-flex lg6 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mr-2 mb-6 rounded-lg pa-4' : 'mr-2 mb-6 rounded-lg pa-4'" height="400px" flat>
          <div ref="topOrganizationCard">
            <div class="mt-2 ml-4 font-weight-medium" style="font-size: 22px;">
              Top Organization
            </div>
            <div class="ml-4 mb-1 grey--text" style="font-size: 15px;">
              Frequently Mention Organizations
            </div>

            <apexchart
              :options="barChartOrganization"
              :series="seriesBarOrganization"
              type="bar"
              height="300"
              @click="clickChartBarOrganization"
            ></apexchart>
          </div>
        </v-card>
      </v-flex>

      <v-flex lg12 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mx-5 mr-2 mb-6 rounded-lg pa-4' : 'ml-4 mr-2 mb-6 rounded-lg pa-4'" height="550px" flat>
          <div class="mt-2 ml-4 font-weight-medium" style="font-size: 22px;">
            Content List
          </div>
          <div class="ml-4 mb-1 grey--text" style="font-size: 15px;">
            Filtered Content Display
          </div>

          <v-tabs v-model="selectedTab" :key="selectedTab" color="#0471A5">
            <v-tab ref="positiveTab" @click="contentListSentiment('Positive')">
              Positive
              <v-chip small class="ma-2" color="#0471A5" text-color="white">
                {{ beritaPositivePersen }} % / {{ beritaPositive }} Data
              </v-chip>
            </v-tab>
            <v-tab ref="neutralTab" class="ml-8" @click="contentListSentiment('Neutral')">
              Neutral
              <v-chip small class="ma-2" color="#0471A5" text-color="white">
                {{ beritaNetralPersen }} % / {{ beritaNetral }} Data
              </v-chip>
            </v-tab>
            <v-tab ref="negativeTab" class="ml-8" @click="contentListSentiment('Negative')">
              Negative
              <v-chip small class="ma-2" color="#1A8EC5" text-color="white">
                {{ beritaNegativePersen }} % / {{ beritaNegative }} Data
              </v-chip>
            </v-tab>

            <v-tab-item style="background-color: #fff">
              <v-card class="elevation-0 overflow-card" height="405px">
                <v-row class="ma-2">
                  <v-flex v-for="(item, index) in kontenBeritaPositive" :key="item.id" lg12>
                    <v-card
                      :href="item.url"
                      target="_blank"
                      flat
                      :class="{ 'rounded-lg content-list-card': index == 0, 'mt-2 rounded-lg content-list-card': index != 0 }"
                      style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                    >
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.title }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.content }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                                <div class="d-flex align-center">
                                  <v-avatar v-if="item.source == 'NEWS'" class="color-avatar-berita-online" size="26">
                                    <v-icon class="white--text" size="18">
                                      fa-thin fa-globe
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'TWITTER'" class="color-avatar-x-tik-tok" size="26">
                                    <v-icon class="white--text" size="22">
                                      fa-brands fa-x-twitter
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'YOUTUBE'" class="color-avatar-ytb" size="26">
                                    <v-icon class="white--text" size="18">
                                      fa-brands fa-youtube
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'TIKTOK'" class="color-avatar-x-tik-tok" size="26">
                                    <v-icon class="white--text" size="22">
                                      fa-brands fa-tiktok
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'INSTAGRAM'" class="color-avatar-ig" size="26">
                                    <v-icon class="white--text" size="22">
                                      mdi-instagram
                                    </v-icon>
                                  </v-avatar>

                                  <span class="ml-1" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                    {{ item.url }}
                                  </span>
                                </div>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                      </div>
                    </v-card>
                  </v-flex>
                </v-row>
              </v-card>
            </v-tab-item>

            <v-tab-item style="background-color: #fff">
              <v-card class="elevation-0 overflow-card" height="405px">
                <v-row class="ma-2">
                  <v-flex v-for="(item, index) in kontenBeritaNetral" :key="item.id" lg12>
                    <v-card
                      :href="item.url"
                      target="_blank"
                      flat
                      :class="{ 'rounded-lg content-list-card': index == 0, 'mt-2 rounded-lg content-list-card': index != 0 }"
                      style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                    >
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.title }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.content }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                                <div class="d-flex align-center">
                                  <v-avatar v-if="item.source == 'NEWS'" class="color-avatar-berita-online" size="26">
                                    <v-icon class="white--text" size="18">
                                      fa-thin fa-globe
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'TWITTER'" class="color-avatar-x-tik-tok" size="26">
                                    <v-icon class="white--text" size="22">
                                      fa-brands fa-x-twitter
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'YOUTUBE'" class="color-avatar-ytb" size="26">
                                    <v-icon class="white--text" size="18">
                                      fa-brands fa-youtube
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'TIKTOK'" class="color-avatar-x-tik-tok" size="26">
                                    <v-icon class="white--text" size="22">
                                      fa-brands fa-tiktok
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'INSTAGRAM'" class="color-avatar-ig" size="26">
                                    <v-icon class="white--text" size="22">
                                      mdi-instagram
                                    </v-icon>
                                  </v-avatar>

                                  <span class="ml-1" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                    {{ item.url }}
                                  </span>
                                </div>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                      </div>
                    </v-card>
                  </v-flex>
                </v-row>
              </v-card>
            </v-tab-item>

            <v-tab-item style="background-color: #fff">
              <v-card class="elevation-0 overflow-card" height="405px">
                <v-row class="ma-2">
                  <v-flex v-for="(item, index) in kontenBeritaNegative" :key="item.id" lg12>
                    <v-card
                      :href="item.url"
                      target="_blank"
                      flat
                      :class="{ 'rounded-lg content-list-card': index == 0, 'mt-2 rounded-lg content-list-card': index != 0 }"
                      style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                    >
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.title }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                                {{ item.content }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                                <div class="d-flex align-center">
                                  <v-avatar v-if="item.source == 'NEWS'" class="color-avatar-berita-online" size="26">
                                    <v-icon class="white--text" size="18">
                                      fa-thin fa-globe
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'TWITTER'" class="color-avatar-x-tik-tok" size="26">
                                    <v-icon class="white--text" size="22">
                                      fa-brands fa-x-twitter
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'YOUTUBE'" class="color-avatar-ytb" size="26">
                                    <v-icon class="white--text" size="18">
                                      fa-brands fa-youtube
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'TIKTOK'" class="color-avatar-x-tik-tok" size="26">
                                    <v-icon class="white--text" size="22">
                                      fa-brands fa-tiktok
                                    </v-icon>
                                  </v-avatar>

                                  <v-avatar v-if="item.source == 'INSTAGRAM'" class="color-avatar-ig" size="26">
                                    <v-icon class="white--text" size="22">
                                      mdi-instagram
                                    </v-icon>
                                  </v-avatar>

                                  <span class="ml-1" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                    {{ item.url }}
                                  </span>
                                </div>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                      </div>
                    </v-card>
                  </v-flex>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
        <div v-if="tabsSentiment == 'Positive'" class="text-center">
          <v-pagination
            class="mt-2 my-2"
            v-model="pagePositive"
            :length="pageLengthPositive"
            :total-visible="10"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="handlePageChangePositive"
          ></v-pagination>
        </div>
        <div v-if="tabsSentiment == 'Neutral'" class="text-center">
          <v-pagination
            class="mt-2 my-2"
            v-model="pageNetral"
            :length="pageLengthNetral"
            :total-visible="10"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="handlePageChangeNetral"
          ></v-pagination>
        </div>
        <div v-if="tabsSentiment == 'Negative'" class="text-center">
          <v-pagination
            class="mt-2 my-2"
            v-model="pageNegative"
            :length="pageLengthNegative"
            :total-visible="10"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="handlePageChangeNegative"
          ></v-pagination>
        </div>
      </v-flex>

      <v-overlay v-model="overlayDialogLoading">
        <v-dialog v-model="dialogLoading" persistent max-width="290">
          <v-card>
            <v-card-title class="text-h6 font-weight-medium align-center justify-center">
              Page loading
            </v-card-title>
            <v-card-text class="body-1 align-center justify-center">
              {{ isCapture ? 'Loading capture, please wait' : 'Loading content, please wait' }}
            </v-card-text>
            <v-card-title class="align-center justify-center pt-2 pb-4">
              <v-progress-circular
                color="var(--color-theme)"
                :size="70"
                :width="7"
                indeterminate
              ></v-progress-circular>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="var(--color-theme)"
                text
                @click="overlayDialogLoading = false, dialogLoading = false"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-overlay>

      <v-dialog v-model="dialogSearchContext" height="500" width="350">
        <v-card class="pa-5" color="var(--color-theme-secondary)" rounded="lg" dark>
          <v-btn class="btn-close-dialog-search-context" icon @click="dialogSearchContext = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-card-text class="text-center" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 20px;">
            <h3 class="white--text mb-4">
              Keyword Search Results
            </h3>
            <p class="white--text">
              Topic: <strong>{{ searchContextTopic }}</strong> <br>
              From: <strong>{{ searchContextStartDate }}</strong> to <strong>{{ searchContextEndDate }}</strong>
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogConfirmReset" width="330px">
        <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
          <v-btn class="confirm-reset ma-0 pa-0" color="#aaa" small icon @click="dialogConfirmReset = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-avatar style="border: 2px solid #ddd;" color="#eee" size="80">
            <v-icon class="white--text" size="80">
              mdi-check
            </v-icon>
          </v-avatar>

          <h1 class="mt-2 text-center text-h6 align-center justify-center">
            Are you sure?
          </h1>

          <v-card-text class="align-center justify-center mt-2">
            Are you sure you want to reset?
          </v-card-text>

          <v-divider class="mt-4"></v-divider>

          <v-card-actions class="align-center justify-center">
            <v-btn
              color="#0471A5"
              width="120px"
              height="40px"
              style="border-radius: 8px"
              size="large"
              dark
              outlined
              @click="dialogConfirmReset = false"
            >
              Cancel
            </v-btn>
            <v-btn
              class="my-3"
              width="120px"
              height="40px"
              style="border-radius: 8px"
              color="#e30700"
              size="large"
              dark
              @click="
                dialogConfirmReset = false,
                isClickSentiment = false,
                statusFilter = '',
                colorWordCloudNews = '',
                colorWordCloudSocialMedia = '',
                nerPersonSearch = '',
                nerOrganizationSearch = '',
                loadTopic(),
                filterReset()
              "
            >
              Reset
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
<!-- 
      <div
        v-if="tooltipTagCloud.visible"
        :style="{
          top: tooltipTagCloud.top + 'px',
          left: tooltipTagCloud.left + 'px'
        }"
        class="tooltip-tagcloud"
      >
        <b style="font-size: 16px;">{{ tooltipTagCloud.data.name }}</b>
        <div style="margin-top: 4px;">
          <span class="tooltip-label">Value:</span>
          <span class="tooltip-value">
            {{ tooltipTagCloud.data.value }}
            ({{ tooltipTagCloud.type == 'news' ? (totalWordsNews ? Math.round((tooltipTagCloud.data.value / totalWordsNews) * 100) : 0) : (totalWordsSocmed ? Math.round((tooltipTagCloud.data.value / totalWordsSocmed) * 100) : 0) }}%)
          </span>
        </div>
      </div> -->

      <v-dialog v-model="dialogPageInsight" attach="#floating-dialog-anchor" width="340" scrollable hide-overlay>
        <v-card style="position: fixed; bottom: 120px; right: 30px; border-radius: 12px; height: 460px; width: 60%" elevation="8">
          <v-card-title class="white--text" :style="{ backgroundColor: 'var(--color-theme)' }">
            <SparklesIcon class="w-4 h-4" style="color: white;" />
            <span class="ml-2 font-weight-bold">
              Insights AI Assistant
            </span>
            <v-spacer></v-spacer>
            <v-btn icon @click="regenerateInsight">
              <v-icon
                color="white"
                :class="{ 'rotate-animation': isRotatingRegenerateInsight }"
                style="transform: rotate(90deg);"
              >
                mdi-sync
              </v-icon>
            </v-btn>
            <v-btn icon @click="dialogPageInsight = false">
              <v-icon color="white">
                mdi-close
              </v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="mt-5" style="max-height: 345px; overflow-y: auto;">
            <div v-if="loadingResponseDescribeDashboard && listResponseDescribeDashboard.length == 0" class="loading-dots">
              <span>.</span><span>.</span><span>.</span>
            </div>

            <div
              v-if="
                !loadingResponseDescribeDashboard &&
                listResponseDescribeDashboard.length == 1 &&
                listResponseDescribeDashboard[0] == 'The server is busy. Please try again later.'
              "
            >
              <div class="d-flex justify-end">
                <div
                  class="response-textdescribedashboard rounded-lg"
                  style="width: 100%"
                  v-html="formatTextDescribeDashboard(listResponseDescribeDashboard[0])"
                ></div>
              </div>
            </div>

            <div v-else v-for="(item, index) in listResponseDescribeDashboard" :key="index" class="mb-2">
              <template v-if="currentLoadingIndex == index">
                <div class="loading-dots">
                  <span>.</span><span>.</span><span>.</span>
                </div>
              </template>
              <template v-else-if="currentLoadingIndex > index">
                <div class="d-flex justify-end">
                  <div
                    class="response-textdescribedashboard rounded-lg"
                    style="width: 100%"
                    v-html="formatTextDescribeDashboard(item)"
                  ></div>
                </div>
              </template>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogSuccessGenerateNewsletter"
        persistent
        max-width="330px"
      >
        <v-card
          class="text-center align-center justify-center pa-6 rounded-lg"
          width="330px"
        >
          <v-avatar
            color="var(--color-theme)"
            style="border: 2px solid var(--color-theme);"
            size="80"
          >
            <v-icon class="white--text" size="80">
              mdi-check
            </v-icon>
          </v-avatar>

          <h1 class="mt-2 text-center text-h6 align-center justify-center" style="text-wrap: wrap">
            Newsletter successfully generated
          </h1>

          <v-divider class="mt-4"></v-divider>

          <v-card-actions class="align-center justify-center">
            <v-btn
              color="var(--color-theme)"
              style="border-radius: 8px"
              size="large"
              height="40px"
              width="120px"
              dark
              @click="dialogSuccessGenerateNewsletter = false"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div id="floating-dialog-anchor"></div>

      <div>
        <Notification ref="alert"></Notification>
      </div>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import VueWordcloud from 'vue-wordcloud/src/components/WordCloud.vue';
import Notification from '@/components/Notification';
import { decryptionData, generateFilterDate, processTopicKeywords, trackEvent } from '@/components/utils/utils.js';
import { mapGetters } from 'vuex';
import { SparklesIcon } from "@vue-hero-icons/solid";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
// import io from 'socket.io-client';
// let ipSocket = process.env.VUE_APP_API;

export default {
  components: {
    VueWordcloud,
    Notification: Notification,
    SparklesIcon
  },
  data: function() {
    return {
      base64HeaderSolusi247: null,
      dialogSuccessGenerateNewsletter: false,
      isCapture: false,
      tagCloudInsights: [],
      topPersonOrganizationInsights: [],
      isRotatingRegenerateInsight: false,
      listIndexOpenInsight: [],
      indexOpenInsight: 0,
      dialogPageInsight: false,
      loadingResponseDescribeDashboard: false,
      listResponseDescribeDashboard: [],
      currentLoadingIndex: 0,
      lastCalculatedOn: '-',
      selectedTopic: "",
      selectedKeyword: "",
      selectedPeriode: "This Week",
      topicSentiment: [],
      topicKeywordSentiment: [],
      periodeBerita: [
        { name: 'Today', value: 'Today' },
        { name: 'From Yesterday', value: 'From Yesterday' },
        { name: 'This Week', value: 'This Week' },
        { name: 'From Previous Week', value: 'Previous Week' },
        { name: 'This Month', value: 'This Month' },
        { name: 'Previous Month', value: 'Previous Month' }
      ],
      isShowDate: false,
      showDateStart: "",
      showDateEnd: "",
      menu: false,
      dateStart: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      dateEnd: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      isSearch: false,
      overlayDialogLoading: false,
      dialogLoading: false,
      dialogSearchContext: false,
      searchContextTopic: "",
      searchContextStartDate: "",
      searchContextEndDate: "",
      alert: false,
      colorAlert: "",
      message: "",
      dialogConfirmReset: false,
      seriesDonut: [],
      chartPie: {
        colors: ['#008FFB', '#FF4560', '#00E396'],
        chart: {
          width: 380,
          type: 'pie',
        },
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  color: '#226077',
                  offsetY: -10,
                },
                total: {
                  show: true,
                },
              }
            }
          }
        },
        states: {
          active: {
            filter: {
              type: 'none'
            }
          }
        },
        labels: ['Neutral', 'Negative', 'Positive'],
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
        },
        tooltip: {
          y: {
            formatter: function(val, opts) {
              try {
                const series = opts.series || (opts.globals && opts.globals.series);
                if (series && Array.isArray(series)) {
                  const total = series.reduce((a, b) => a + b, 0);
                  const percentage = total > 0 ? ((val / total) * 100).toFixed(2) : 0;
                  return val + " (" + percentage + "%)";
                }
              } catch (e) {
                console.error("Tooltip formatter error:", e);
              }
              return val;
            }
          }
        },
      },
      isClickSentiment: false,
      statusFilter: "",
      wordsNewsInitial: [],
      wordsNews: [],
      wordsSocialMediaInitial: [],
      wordsSocialMedia: [],
      loadingTagCloud: false,
      wordCloudKeyNews: 0,
      colorWordCloudNews: "",
      fontSizeTagCloudNews: [10, 30],
      wordCloudKeySocialMedia: 0,
      colorWordCloudSocialMedia: "",
      fontSizeTagCloudSocialMedia: [10, 30],
      rotateTagCloud: { from: 0, to: 0 },
      selectedWordDetail: "",
      lastFetchedKeyword: "",
      nerPersonInitial: [],
      nerOrganizationInitial: [],
      seriesBarPerson: [{
        data: []
      }],
      barChartPerson: {
        colors: ['#38BABC', '#16A5A7', '#079092'],
        chart: {
          height: 100,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            columnWidth: '45%',
            distributed: true,
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '12px'
            },
            show: true,
            rotate: -45,
            rotateAlways: true,
            hideOverlappingLabels: false,
            trim: false,
            maxHeight: 120
          },
          tickAmount: 'dataPoints'
        },
        tooltip: {
          custom: function({ seriesIndex, dataPointIndex, w }) {
            const dataPoint = w.config.series[seriesIndex].data[dataPointIndex];

            const fullName = dataPoint.fullName || dataPoint.x;
            const count = dataPoint.count || dataPoint.y;
            const mediaCount = dataPoint.domainsCount || 0;
            const socmedCount = dataPoint.socmedCount || 0;

            const positive = dataPoint.sentiment?.positive || 0;
            const negative = dataPoint.sentiment?.negative || 0;
            const neutral = dataPoint.sentiment?.neutral  || 0;

            const total = count || 1;

            const positiveRaw = (positive / total) * 100;
            const negativeRaw = (negative / total) * 100;
            const neutralRaw = (neutral  / total) * 100;

            let positivePercent = Math.round(positiveRaw);
            let negativePercent = Math.round(negativeRaw);
            let neutralPercent = 100 - positivePercent - negativePercent;

            return `
              <div style="border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.3); line-height: 1.4; padding: 10px;">
                <b style="font-size:16px;">${fullName}</b><br/>
                ${count} contents<br/>
                <div style="margin-top:8px; background-color:white;">
                  Detected in contents from <b>${mediaCount}</b> online media,<br/>
                  and <b>${socmedCount}</b> social media,<br/>
                  with <b>${positivePercent}%</b> positive sentiment,<br/>
                  <b>${negativePercent}%</b> negative sentiment,<br/>
                  and <b>${neutralPercent}%</b> neutral sentiment.
                </div>
              </div>
            `;
          }
        }
      },
      seriesBarOrganization: [{
        data: []
      }],
      barChartOrganization: {
        colors: ['#38BABC', '#16A5A7', '#079092'],
        chart: {
          height: 100,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            columnWidth: '45%',
            distributed: true,
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '12px'
            },
            show: true,
            rotate: -45,
            rotateAlways: true,
            hideOverlappingLabels: false,
            trim: false,
            maxHeight: 120
          },
          tickAmount: 'dataPoints'
        },
        tooltip: {
          custom: function({ seriesIndex, dataPointIndex, w }) {
            const dataPoint = w.config.series[seriesIndex].data[dataPointIndex];

            const fullName = dataPoint.fullName || dataPoint.x;
            const count = dataPoint.count || dataPoint.y;
            const mediaCount = dataPoint.domainsCount || 0;
            const socmedCount = dataPoint.socmedCount || 0;

            const positive = dataPoint.sentiment?.positive || 0;
            const negative = dataPoint.sentiment?.negative || 0;
            const neutral = dataPoint.sentiment?.neutral  || 0;

            const total = count || 1;

            const positiveRaw = (positive / total) * 100;
            const negativeRaw = (negative / total) * 100;
            const neutralRaw = (neutral  / total) * 100;

            let positivePercent = Math.round(positiveRaw);
            let negativePercent = Math.round(negativeRaw);
            let neutralPercent = 100 - positivePercent - negativePercent;

            return `
              <div style="border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.3); line-height: 1.4; padding: 10px;">
                <b style="font-size:16px;">${fullName}</b><br/>
                ${count} contents<br/>
                <div style="margin-top:8px; background-color:white;">
                  Detected in contents from <b>${mediaCount}</b> online media,<br/>
                  and <b>${socmedCount}</b> social media,<br/>
                  with <b>${positivePercent}%</b> positive sentiment,<br/>
                  <b>${negativePercent}%</b> negative sentiment,<br/>
                  and <b>${neutralPercent}%</b> neutral sentiment.
                </div>
              </div>
            `;
          }
        }
      },
      nerPersonSearch: "",
      nerOrganizationSearch: "",
      // socket: io(ipSocket),
      kontenBeritaAllInitial: {
        positive: [],
        neutral: [],
        negative: [],
        all: [],
      },
      kontenBeritaAll: {
        positive: [],
        neutral: [],
        negative: [],
        all: [],
      },
      kontenBeritaPositive: [],
      kontenBeritaNetral: [],
      kontenBeritaNegative: [],
      pageUrlkontenBeritaPositive: [],
      pageUrlkontenBeritaNetral: [],
      pageUrlkontenBeritaNegative: [],
      beritaPositivePersen: "",
      beritaPositive: "",
      beritaNetralPersen: "",
      beritaNetral: "",
      beritaNegativePersen: "",
      beritaNegative: "",
      pageLengthPositive: "",
      pageLengthNetral: "",
      pageLengthNegative: "",
      selectedTab: 0,
      tabsSentiment: "Positive",
      itemsPerPage: 10,
      pageplay: 100,
      pagePositive: 1,
      pageNetral: 1,
      pageNegative: 1,
    }
  },
  computed: {
    ...mapGetters(['navbarWithName']),
    themeItemColor() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700' ? 'var(--color-theme)' : undefined;
    },
    isColorThemeSetneg() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700';
    },
  },
  async created() {
    await this.loadAssetsTheme();
  },
  mounted() {
    this.loadTopic();
    // this.getRealTimeData();

    document.body.addEventListener('mouseover', (e) => {
      if (e.target.tagName === 'text' && e.target.classList.contains('text')) {
        const cloudContainer = e.target.closest('.wordcloud-class');
        if (cloudContainer) {
          const text = e.target.textContent;
          const item = this.wordsNews.find(w => w.name === text) ||
                       this.wordsSocialMedia.find(w => w.name === text);

          if (item && item.percentage !== undefined) {
            setTimeout(() => {
              const tooltips = document.querySelectorAll('div.tooltip:not(.v-tooltip__content)');
              tooltips.forEach(tooltip => {
                if (tooltip.style.opacity > 0 && !tooltip.innerHTML.includes('%')) {
                   tooltip.innerHTML = tooltip.innerHTML.replace(/(value: [^<]+)/, `$1 <span style="position: relative; top: -1px; font-size: 13px;">(${item.percentage}%)</span>`);
                }
              });
            }, 50);
          }
        }
      }
    });
  },
  methods: {
    async loadAssetsTheme() {
      try {
        const appTitle = window.APP_CONFIG?.VUE_APP_TITLE || process.env.VUE_APP_TITLE;
        const assetsModule = appTitle == "Websitemedan"
          ? await import('@/constants/asset-logo-MedAn.js')
          : await import('@/constants/asset-logo-Garuda.js');

        this.base64HeaderSolusi247 = assetsModule.BASE64_HEADER_SOLUSI247;
      } catch (error) {
        console.error('Failed to load environment assets:', error);
      }
    },
    async captureAll() {
      try {
        this.isCapture = true;
        this.overlayDialogLoading = true;
        this.dialogLoading = true;

        const tagCloudNewsCard = this.$refs.tagCloudNewsCard;
        const tagCloudSocialMediaCard = this.$refs.tagCloudSocialMediaCard;
        const topPersonCard = this.$refs.topPersonCard;
        const topOrganizationCard = this.$refs.topOrganizationCard;

        const [_, canvasResults] = await Promise.all([
          this.insightsAICaptureAll(),
          (async () => {
            const [canvasNews, canvasSocial, canvasPerson, canvasOrganization] = await Promise.all([
              html2canvas(tagCloudNewsCard, { backgroundColor: '#ffffff', scale: 2 }),
              html2canvas(tagCloudSocialMediaCard, { backgroundColor: '#ffffff', scale: 2 }),
              html2canvas(topPersonCard, { backgroundColor: '#ffffff', scale: 2 }),
              html2canvas(topOrganizationCard, { backgroundColor: '#ffffff', scale: 2 })
            ]);
            return { canvasNews, canvasSocial, canvasPerson, canvasOrganization };
          })(),
        ]);

        const { canvasNews, canvasSocial, canvasPerson, canvasOrganization } = canvasResults;

        const imgDataNews = canvasNews.toDataURL('image/png');
        const imgDataSocial = canvasSocial.toDataURL('image/png');
        const imgDataPerson = canvasPerson.toDataURL('image/png');
        const imgDataOrganization = canvasOrganization.toDataURL('image/png');

        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        this.createStandardPageHeader(pdf, pageWidth);

        const footerY = pageHeight - 8;
        pdf.setFontSize(11);
        pdf.setFont(undefined, "normal");
        pdf.setTextColor("#808080");
        pdf.text("HALAMAN 2", 15, footerY);

        const marginX = 15;
        const titleYRow1 = 31;
        const contentFontSize = '13px';
        const contentHeight = pageHeight * 0.45;
        const columnWidth = pageWidth - (2 * marginX);
        const contentYStartRow1 = titleYRow1 + 6;
        const imgWidth = (columnWidth / 2) - 5;

        pdf.setFontSize(18);
        pdf.setTextColor('#165476');
        pdf.setFont(undefined, 'bold');
        pdf.text('Analisis Bahasan Populer di Masyarakat', marginX, titleYRow1, { align: 'left' });

        let insightText = '';
        if (this.tagCloudInsights && this.tagCloudInsights.length > 0) {
          this.tagCloudInsights.forEach(section => {
            insightText += this.formatTextReportTrendingTopic(section) + '\n\n';
          });
          insightText = insightText.trim();
        }

        let styledHTML = insightText
          .replace(/^# (.*$)/gim, '<h1 style="font-size:16px; font-weight:bold; margin:3px 0;">$1</h1>')
          .replace(/^## (.*$)/gim, '<h2 style="font-size:15px; font-weight:bold; margin:3px 0;">$1</h2>')
          .replace(/^### (.*$)/gim, '<h3 style="font-size:14px; font-weight:600; margin:2px 0;">$1</h3>')
          .replace(/\*\*(.*?)\*\*/gim, '<b>$1</b>')
          .replace(/\*(.*?)\*/gim, '<i>$1</i>')
          .replace(/\n/g, '<br>');

        const imgX = marginX;
        const imgYStartRow1 = contentYStartRow1 - 4.5;

        const imgHeightNews = (canvasNews.height * imgWidth) / canvasNews.width + 20;
        const imgHeightSocial = (canvasSocial.height * imgWidth) / canvasSocial.width + 20;
        const totalImageHeight = imgHeightNews + imgHeightSocial + 5;

        let scale = 1;
        if (totalImageHeight > contentHeight) {
          scale = contentHeight / totalImageHeight;
        }

        const scaledHeightNews = imgHeightNews * scale;
        const scaledHeightSocial = imgHeightSocial * scale;

        pdf.addImage(imgDataNews, 'PNG', imgX, imgYStartRow1, imgWidth, scaledHeightNews);
        pdf.addImage(imgDataSocial, 'PNG', imgX, imgYStartRow1 + scaledHeightNews + 3, imgWidth, scaledHeightSocial);

        const textX = imgX + imgWidth + 5;
        const textWrapWidth = columnWidth - imgWidth - 5;
        const availableHeightWrap = contentHeight - 5;
        const windowWidthForWrap = Math.round(600 * (textWrapWidth / columnWidth));

        await pdf.html(
          `<div style="font-family: Helvetica; font-size:${contentFontSize}; line-height:1.5; color:#000;">${styledHTML}</div>`,
          {
            x: textX,
            y: contentYStartRow1,
            width: textWrapWidth,
            height: availableHeightWrap,
            windowWidth: windowWidthForWrap,
            autoPaging: 'none',
          }
        );

        const titleYRow2 = contentYStartRow1 + contentHeight;
        const contentYStartRow2 = titleYRow2 + 4;

        pdf.setFontSize(18);
        pdf.setTextColor('#165476');
        pdf.setFont(undefined, 'bold');
        pdf.text('Entitas pada Bahasan Masyarakat', marginX, titleYRow2, { align: 'left' });

        let personOrganizationInsightText = '';
        if (this.topPersonOrganizationInsights && this.topPersonOrganizationInsights.length > 0) {
          this.topPersonOrganizationInsights.forEach(section => {
            personOrganizationInsightText += this.formatTextReportTrendingTopic(section) + '\n\n';
          });
          personOrganizationInsightText = personOrganizationInsightText.trim();
        }

        let styledHTMLRow2 = personOrganizationInsightText
          .replace(/^# (.*$)/gim, '<h1 style="font-size:16px; font-weight:bold; margin:3px 0;">$1</h1>')
          .replace(/^## (.*$)/gim, '<h2 style="font-size:15px; font-weight:bold; margin:3px 0;">$1</h2>')
          .replace(/^### (.*$)/gim, '<h3 style="font-size:14px; font-weight:600; margin:2px 0;">$1</h3>')
          .replace(/\*\*(.*?)\*\*/gim, '<b>$1</b>')
          .replace(/\*(.*?)\*/gim, '<i>$1</i>')
          .replace(/\n/g, '<br>');

        const textXRow2 = imgX;
        const textWrapWidthRow2 = imgWidth;
        const availableHeightWrapRow2 = contentHeight - 5;
        const windowWidthForWrapRow2 = Math.round(600 * (textWrapWidthRow2 / columnWidth));

        await pdf.html(
          `<div style="font-family: Helvetica; font-size:${contentFontSize}; line-height:1.5; color:#000;">${styledHTMLRow2}</div>`,
          {
            x: textXRow2,
            y: contentYStartRow2,
            width: textWrapWidthRow2,
            height: availableHeightWrapRow2,
            windowWidth: windowWidthForWrapRow2,
            autoPaging: 'none',
          }
        );

        const imgHeightPerson = (canvasPerson.height * imgWidth) / canvasPerson.width + 20;
        const imgHeightOrganization = (canvasOrganization.height * imgWidth) / canvasOrganization.width + 20;
        const totalImageHeightRow2 = imgHeightPerson + imgHeightOrganization + 5;

        let scaleRow2 = 1;
        if (totalImageHeightRow2 > contentHeight - 5) {
          scaleRow2 = (contentHeight - 5) / totalImageHeightRow2;
        }

        const scaledHeightPerson = imgHeightPerson * scaleRow2;
        const scaledHeightOrganization = imgHeightOrganization * scaleRow2;

        const imgXRow2 = textX;
        const imgYStartRow2 = contentYStartRow2 - 2;

        pdf.addImage(imgDataPerson, 'PNG', imgXRow2, imgYStartRow2, imgWidth, scaledHeightPerson);
        pdf.addImage(
          imgDataOrganization,
          'PNG',
          imgXRow2,
          imgYStartRow2 + scaledHeightPerson + 3,
          imgWidth,
          scaledHeightOrganization
        );

        const pdfBytes = pdf.output("arraybuffer");

        const formattedDate = new Date().toLocaleString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });

        const now = new Date();
        const monthShort = now.toLocaleString("en-US", { month: "short" });
        const year = now.getFullYear();

        const getWeekOfMonth = (d = new Date()) => {
          const date = new Date(d.getFullYear(), d.getMonth(), d.getDate());
          const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
          const dayOfMonth = date.getDate();
          const firstDayWeekday = firstDayOfMonth.getDay();

          return Math.ceil((dayOfMonth + firstDayWeekday) / 7);
        };

        let title = "";
        const topicName = this.searchContextTopic;

        switch (this.selectedPeriode) {
          case "Today":
            title = `${topicName} Today Insights Trending Topic`;
            break;
          case "Tomorrow":
            title = `${topicName} Tomorrow Insights Trending Topic`;
            break;
          case "This Week":
            title = `${topicName} Week ${getWeekOfMonth()} ${monthShort} Insights Trending Topic`;
            break;
          case "Previous Week": {
            const prevWeekDate = new Date(now);
            prevWeekDate.setDate(now.getDate() - 7);
            const prevWeekMonth = prevWeekDate.toLocaleString("en-US", { month: "short" });
            const weekNum = getWeekOfMonth(prevWeekDate);
            title = `${topicName} Week ${weekNum} ${prevWeekMonth} Insights Trending Topic`;
            break;
          }
          case "This Month":
            title = `${topicName} ${monthShort} ${year} Insights Trending Topic`;
            break;
          case "Previous Month": {
            const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            const prevMonthShort = prev.toLocaleString("en-US", { month: "short" });
            const prevYear = prev.getFullYear();
            title = `${topicName} ${prevMonthShort} ${prevYear} Insights Trending Topic`;
            break;
          }
          default:
            title = `${topicName} Insights Trending Topic`;
        }

        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const formData = new FormData();
        formData.append('file', new Blob([pdfBytes], { type: 'application/pdf' }), `${title}.pdf`);
        formData.append('title', title);
        formData.append('nameFile', `${title}.pdf`);
        formData.append('type', 'newsletter trendingtopic');
        formData.append('date', formattedDate);
        formData.append('topic', this.selectedTopic);
        formData.append('periode', this.selectedPeriode);

        const responseNewsletterTrendingtopic = await axios.post(
          "insights/upload",
          formData,
          {
            headers: {
              "auth-token": authToken,
            },
          }
        );

        if (responseNewsletterTrendingtopic.status == 200) {
          this.dialogSuccessGenerateNewsletter = true;
        }

        this.isCapture = false;
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      } catch (error) {
        console.error('Gagal melakukan capture atau menyimpan:', error);
        this.isCapture = false;
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      }
    },
    createStandardPageHeader(doc, pageWidth) {
      const now = new Date();
      const monthName = now.toLocaleString('en-US', { month: 'long' }).toUpperCase();
      const year = now.getFullYear();
      const headerDateText = `${monthName} ${year}`;

      const headerText = `${headerDateText} | SOLUSI247 NEWSLETTER`;

      const logoBase64 = this.base64HeaderSolusi247;
      const logoWidth = 50;
      const logoHeight = 15;
      const marginX = 15;
      const headerY = 15;
      const lineY = headerY + 5;

      doc.setFontSize(11);
      doc.setFont(undefined, "normal");
      doc.setTextColor("#555555");
      doc.text(headerText, marginX, headerY);

      const logoX = pageWidth - logoWidth - marginX;
      const logoY = headerY - 10;

      if (typeof logoBase64 !== "undefined" && logoBase64.length > 0) {
        doc.addImage(logoBase64, "PNG", logoX, logoY, logoWidth, logoHeight);
      }

      doc.setDrawColor(180, 180, 180);
      doc.setLineWidth(0.5);
      doc.line(marginX, lineY, pageWidth - marginX, lineY);
    },
    async insightsAICaptureAll() {
      try {
        const token = localStorage.getItem('token_app');

        try {
          const decodeResponse = await axios.post("decode-token", { token });

          if (!decodeResponse.data.valid) {
            throw { response: { status: 403 } };
          }
        } catch (e) {
          const { status } = e.response || {};

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
          return;
        }

        const axiosInstance = axios.create({
          baseURL: "/apigenerativeAI",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');

        let chosen_tag_cloud = [];
        if (this.selectedWordDetail && this.selectedWordDetail.name) {
          chosen_tag_cloud.push(this.selectedWordDetail.name);
        } else if (this.selectedWordDetail && this.selectedWordDetail.text) {
          chosen_tag_cloud.push(this.selectedWordDetail.text);
        }

        const payload = {
          topic: this.searchContextTopic,
          period: periode,
          chosen_tag_cloud: chosen_tag_cloud
        };

        const response = await axiosInstance.post(
          "/gen-ai-medan/api/v2/chat/generate-trending-report",
          payload
        );

        const data = response.data?.data || {};
        let analisisTopik = data.analisis_topik_bahasan_masyarakat || '';
        let entitasBahasan = data.entitas_pada_bahasan_masyarakat || '';

        if (!entitasBahasan.trim() && analisisTopik.includes('# Entitas pada Bahasan Masyarakat')) {
          const sections = analisisTopik.split('# Entitas pada Bahasan Masyarakat');

          if (sections.length == 2) {
            analisisTopik = sections[0].trim();
            entitasBahasan = sections[1].trim();
          }
        }

        if (analisisTopik.startsWith('# Analisis Topik Bahasan Masyarakat')) {
          analisisTopik = analisisTopik.replace(/^#\s*Analisis Topik Bahasan Masyarakat\s*\n*/i, '').trim();
        }

        if (entitasBahasan.startsWith('# Entitas pada Bahasan Masyarakat')) {
          entitasBahasan = entitasBahasan.replace(/^#\s*Entitas pada Bahasan Masyarakat\s*\n*/i, '').trim();
        }

        this.tagCloudInsights = [analisisTopik.trim()];
        this.topPersonOrganizationInsights = [entitasBahasan.trim()];
      } catch (error) {
        console.error("Error in postDescribeTrendingTopic:", error);
        this.tagCloudInsights = ["The server is busy. Please try again later."];
        this.topPersonOrganizationInsights = [];
      }
    },
    formatTextReportTrendingTopic(text) {
      if (!text) return "";

      const lines = text.split('\n');
      let htmlOutput = '';

      lines.forEach(line => {
        let trimmed = line.trim();
        if (!trimmed) return;

        if (trimmed.startsWith('- **') && trimmed.includes('**:')) {
          const match = trimmed.match(/^- \*\*(.+?)\*\*:\s*(.*)$/);
          if (match) {
            const boldText = match[1];
            const content = match[2];
            htmlOutput += `<p style="margin-bottom: 2px;">- ${boldText}:</p>`;
            if (content) {
              htmlOutput += `<p style="margin-bottom: 2px;">${content}</p>`;
            }
            return;
          }
        }

        if (/^\d+\.\s+\*\*/.test(trimmed) && trimmed.includes('**:')) {
          const match = trimmed.match(/^(\d+\.)\s+\*\*(.+?)\*\*:\s*(.*)$/);
          if (match) {
            const number = match[1];
            const boldText = match[2];
            const content = match[3];
            htmlOutput += `<p style="margin-bottom: 2px;">${number} ${boldText}:</p>`;
            if (content) {
              htmlOutput += `<p style="margin-bottom: 2px;">${content}</p>`;
            }
            return;
          }
        }

        trimmed = trimmed.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

        const headingMatch = trimmed.match(/^(#{1,6})\s+(.*)$/);
        if (headingMatch) {
          const level = headingMatch[1].length;
          const content = headingMatch[2];
          htmlOutput += `<h${level}>${content}</h${level}>`;
        } else if (/^\d+\./.test(trimmed)) {
          htmlOutput += `<p style="margin-bottom: 2px;">${trimmed}</p>`;
        } else if (trimmed.startsWith('- ')) {
          htmlOutput += `<p style="margin-bottom: 2px;">${trimmed}</p>`;
        } else {
          htmlOutput += `<p style="margin-bottom: 0px;">${trimmed}</p>`;
        }
      });

      return htmlOutput;
    },
    regenerateInsight() {
      this.isRotatingRegenerateInsight = true;

      setTimeout(() => {
        this.isRotatingRegenerateInsight = false;
      }, 500);

      this.indexOpenInsight = this.listIndexOpenInsight.length - 1;
      this.listIndexOpenInsight[this.indexOpenInsight] = true;
      this.postDescribeTrendingTopic();
      this.dialogPageInsight = true;
    },
    async insightAIassistant() {
      trackEvent('trending-topic-insight-ai');
      this.postDescribeTrendingTopic();
    },
    async postDescribeTrendingTopic() {
      this.dialogPageInsight = !this.dialogPageInsight;
      const currentKeyword = this.selectedWordDetail ? (this.selectedWordDetail.name || this.selectedWordDetail.text) : "";
      if (this.listIndexOpenInsight[this.listIndexOpenInsight.length - 1] != false || this.lastFetchedKeyword != currentKeyword) {
        this.listResponseDescribeDashboard = [];
        this.currentLoadingIndex = 0;
        this.listIndexOpenInsight[this.indexOpenInsight] = false;
        this.indexOpenInsight += 1;
        this.lastFetchedKeyword = currentKeyword;

        this.loadingResponseDescribeDashboard = true;
        try {
          const token = localStorage.getItem('token_app');

          try {
            const decodeResponse = await axios.post("decode-token", { token });

            if (!decodeResponse.data.valid) {
              throw { response: { status: 403 } };
            }
          } catch (e) {
            this.loadingResponseDescribeDashboard = false;
            const { status } = e.response || {};

            switch (status) {
              case 404:
                this.$refs.alert.error_login(404);
                break;
              case 403:
                this.$refs.alert.error_login(403);
                break;
              default:
                console.log("some other error");
                break;
            }
            return;
          }

          const axiosInstance = axios.create({
            baseURL: "/apigenerativeAI",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');

          let chosen_tag_cloud = [];
          if (this.selectedWordDetail && this.selectedWordDetail.name) {
            chosen_tag_cloud.push(this.selectedWordDetail.name);
          } else if (this.selectedWordDetail && this.selectedWordDetail.text) {
            chosen_tag_cloud.push(this.selectedWordDetail.text);
          }

          const payload = {
            topic: this.searchContextTopic,
            period: periode,
            sentiment: "All",
            chosen_tag_cloud: chosen_tag_cloud,
          };

          const response = await axiosInstance.post(
            "/gen-ai-medan/api/v1/chat/describe-trending-topic",
            payload
          );

          const combinedText =
            (response.data.data.tag_cloud_news?.response || '') +
            '\n\n' +
            (response.data.data.tag_cloud_socmed?.response || '');

          const lines = combinedText.replace(/\r/g, '').split('\n');
          this.listResponseDescribeDashboard = [];

          let currentSection = "";
          let isInRincianKonten = false;

          lines.forEach((line, index) => {
            const trimmed = line.trim();
            if (!trimmed) return;

            const headingMatch = trimmed.match(/^(#{1,6})\s+(.*)$/);
            if (headingMatch) {
              const level = headingMatch[1].length;
              const headingText = headingMatch[2];

              if (level == 2 && headingText.includes("Rincian Konten")) {
                if (currentSection) {
                  this.listResponseDescribeDashboard.push(currentSection.trim());
                }
                currentSection = trimmed;
                isInRincianKonten = true;
              } else if (
                isInRincianKonten &&
                level == 3 &&
                (
                  headingText.includes("Konten Positif") ||
                  headingText.includes("Konten Negatif") ||
                  headingText.includes("Konten Netral")
                )
              ) {
                currentSection += '\n' + trimmed;
              } else if (level <= 2) {
                if (currentSection) {
                  this.listResponseDescribeDashboard.push(currentSection.trim());
                  currentSection = "";
                }
                currentSection = trimmed;
                isInRincianKonten = false;
              } else {
                currentSection += '\n' + trimmed;
              }
            } else {
              currentSection += '\n' + trimmed;
            }

            if (index == lines.length - 1 && currentSection) {
              this.listResponseDescribeDashboard.push(currentSection.trim());
            }
          });

          const totalItems = this.listResponseDescribeDashboard.length;
          const interval = setInterval(() => {
            this.currentLoadingIndex++;
            if (this.currentLoadingIndex >= totalItems) {
              clearInterval(interval);
              this.loadingResponseDescribeDashboard = false;
            }
          }, 500);
        } catch (error) {
          console.error("Error in postDescribeTrendingTopic:", error);
          this.loadingResponseDescribeDashboard = false;
          this.listResponseDescribeDashboard = ["The server is busy. Please try again later."];
        }
      }
    },
    formatTextDescribeDashboard(text) {
      if (!text) return "";

      const lines = text.split('\n');
      let htmlOutput = '';

      lines.forEach(line => {
        let trimmed = line.trim();
        if (!trimmed) return;

        if (trimmed.startsWith('- **') && trimmed.includes('**:')) {
          const match = trimmed.match(/^- \*\*(.+?)\*\*:\s*(.*)$/);
          if (match) {
            const boldText = match[1];
            const content = match[2];
            htmlOutput += `<p style="margin-bottom: 2px;">- ${boldText}:</p>`;
            if (content) {
              htmlOutput += `<p style="margin-bottom: 2px;">${content}</p>`;
            }
            return;
          }
        }

        if (/^\d+\.\s+\*\*/.test(trimmed) && trimmed.includes('**:')) {
          const match = trimmed.match(/^(\d+\.)\s+\*\*(.+?)\*\*:\s*(.*)$/);
          if (match) {
            const number = match[1];
            const boldText = match[2];
            const content = match[3];
            htmlOutput += `<p style="margin-bottom: 2px;">${number} ${boldText}:</p>`;
            if (content) {
              htmlOutput += `<p style="margin-bottom: 2px;">${content}</p>`;
            }
            return;
          }
        }

        trimmed = trimmed.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

        const headingMatch = trimmed.match(/^(#{1,6})\s+(.*)$/);
        if (headingMatch) {
          const level = headingMatch[1].length;
          const content = headingMatch[2];
          htmlOutput += `<h${level}>${content}</h${level}>`;
        } else if (/^\d+\./.test(trimmed)) {
          htmlOutput += `<p style="margin-bottom: 2px;">${trimmed}</p>`;
        } else if (trimmed.startsWith('- ')) {
          htmlOutput += `<p style="margin-bottom: 2px;">${trimmed}</p>`;
        } else {
          htmlOutput += `<p style="margin-bottom: 0px;">${trimmed}</p>`;
        }
      });

      return htmlOutput;
    },
    openDialogSearchContext() {
      this.dialogSearchContext = true;
      setTimeout(() => {
        this.dialogSearchContext = false;
      }, 10000);
    },
    async loadTopic() {
      this.isSearch = true;
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      try {
        const [keywordSelectResponse, topicKeywordResponse] = await Promise.all([
          axios.get("keyword_select", {
            headers: { 'auth-token': localStorage.getItem('token_app') },
            dataType: 'json'
          }),
          axios.get("topic-keyword", {
            headers: { 'auth-token': localStorage.getItem('token_app') },
            dataType: 'json'
          })
        ]);

        const dataDecryption = decryptionData(keywordSelectResponse.data.token);
        const data = dataDecryption.keyword;
        const collections = dataDecryption.collection;

        const topicKeywordData = decryptionData(topicKeywordResponse.data.token);
        const topicKeywordList = topicKeywordData.data.filter(item => item.GROUP_STATUS == 1);

        const completedTopicData = processTopicKeywords(data, collections, topicKeywordList);

        if (!data || data.length == 0) {
          this.listSourceCollection = collections;
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
          this.isSearch = false;
          return;
        }

        for (let i = 0; i < completedTopicData.length; i++) {
          if (i == 0) {
            if (this.$store.topic_glob == "" || this.$store.topic_glob === undefined) {
              this.selectedTopic = completedTopicData[i].SEQ_ID;
            } else {
              this.selectedTopic = this.$store.topic_glob;
            }
          }
          this.topicSentiment.push(completedTopicData[i]);
        }

        if (typeof this.selectedTopic === "string") {
          for (let i = 0; i < this.topicSentiment.length; i++) {
            if (this.selectedTopic == this.topicSentiment[i].TOPIC) {
              this.selectedTopic = this.topicSentiment[i].SEQ_ID;
              this.$store.topic_glob = this.selectedTopic;
            }
          }
        }

        this.$store.commit("addTopicKeyword", {
          topickeywordsentiment_glob: completedTopicData,
        });

        this.topicKeywordSentiment = [];
        let all = "All";

        for (let i = 0; i < completedTopicData.length; i++) {
          if (completedTopicData[i].SEQ_ID == this.selectedTopic) {
            this.topicKeywordSentiment.push(all);

            for (let x = 0; x < completedTopicData[i].KEYWORD.length; x++) {
              if (x == 0) {
                if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 === undefined) {
                  this.selectedKeyword = all;
                } else {
                  this.selectedKeyword = this.$store.topic_glob2;
                }
              }
              this.topicKeywordSentiment.push(completedTopicData[i].KEYWORD[x].KEYWORD);
            }
            this.searchContextTopic = data[i].TOPIC;
          }
        }

        this.topicKeywordSentiment = this.topicKeywordSentiment.map((keyword, index) => ({
          text: keyword,
          value: keyword,
          disabled: index != 0,
        }));

        this.isShowDate = this.$store.is_show_date_glob;
        var date_start = this.dateStart;
        var date_end = this.dateEnd;

        if (this.$store.jenis_parameter_glob == "custom") {
          date_start = this.$store.date_start_glob;
          date_end = this.$store.date_end_glob;
        } else {
          let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
          let date_v = generateFilterDate(periode);
          date_start = date_v.start_date;
          date_end = date_v.end_date;
        }

        if (this.$store.date_start_glob == "" || this.$store.date_start_glob === undefined) {
          this.$store.commit("addParameter", {
            jenis_parameter_glob: "periode",
            topic_glob: this.selectedTopic,
            topic_glob2: this.selectedKeyword,
            selectedPeriode_glob: this.selectedPeriode,
            date_start_glob: date_start,
            date_end_glob: date_end,
            is_show_date_glob: this.isShowDate
          });
        } else {
          this.selectedKeyword = this.$store.topic_glob2;
          this.selectedPeriode = this.$store.selectedPeriode_glob;
          this.dateStart = this.$store.date_start_glob;
          this.dateEnd = this.$store.date_end_glob;
        }

        if (data.length > 0) {
          this.loadTrendingTopic();
        } else {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
          this.isSearch = false;
        }

        if (this.isShowDate == true) {
          this.showPeriodeDate();
        }

        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let date_v = generateFilterDate(periode);
        date_start = date_v.start_date;
        date_end = date_v.end_date;
        this.dateStart = date_start;
        this.dateEnd = date_end;

        this.searchContextStartDate = this.dateStart;
        this.searchContextEndDate = this.dateEnd;
      } catch (e) {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        this.isSearch = false;
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Keyword Select Refused To Connect";
          this.colorAlert = "red";
        }
      }
    },
    async parameterProsesTopic() {
      var date_start = this.dateStart;
      var date_end = this.dateEnd;

      this.topicKeywordSentiment = [];
      let all = "All";
      for (let i = 0; i < this.$store.topickeywordsentiment_glob.length; i++) {
        if (this.$store.topickeywordsentiment_glob[i].SEQ_ID == this.selectedTopic) {
          this.topicKeywordSentiment.push(all);
          for (let x = 0; x < this.$store.topickeywordsentiment_glob[i].KEYWORD.length; x++) {
            if (x == 0) {
              if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 === undefined) {
                this.selectedKeyword = all;
              } else {
                this.selectedKeyword = this.$store.topic_glob2;
              }
            }
            this.topicKeywordSentiment.push(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
          }
        }
      }

      this.topicKeywordSentiment = this.topicKeywordSentiment.map((keyword, index) => ({
        text: keyword,
        value: keyword,
        disabled: index != 0,
      }));

      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameterProsesKeyword() {
      var date_start = this.dateStart;
      var date_end = this.dateEnd;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameterProsesPeriode() {
      let date_start = this.dateStart;
      let date_end = this.dateEnd;
      if (this.selectedPeriode != 'Custom') {
        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let date_v = generateFilterDate(periode);
        date_start = date_v.start_date;
        date_end = date_v.end_date;
        this.dateStart = date_start;
        this.dateEnd = date_end;
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "periode",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });

      this.searchContextStartDate = date_start;
      this.searchContextEndDate = date_end;
      this.showPeriodeDate();
    },
    showPeriodeDate() {
      this.isShowDate = true;

      var date = new Date(this.dateStart);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      dateString = dateString.split(" ");
      this.showDateStart = dateString;

      var date3 = new Date(this.dateEnd);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();

      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      dateString2 = dateString2.split(" ");
      this.showDateEnd = dateString2;

      let jenisParameter = "";
      if (this.selectedPeriode == "Custom") {
        jenisParameter = "custom";
      } else {
        jenisParameter = "periode";
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: jenisParameter,
        topic_glob: this.selectedTopic,
        topic_glob2: this.selectedKeyword,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: this.dateStart,
        date_end_glob: this.dateEnd,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameterProsesCustom() {
      this.selectedPeriode = "Custom";
      var date_start = this.dateStart;
      var date_end = this.dateEnd;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
    },
    filterReset() {
      this.$store.commit("addButtonTmp", {
        sentiment_glob: "",
        ner_person_glob: "",
        ner_organization_glob: "",
      });
      trackEvent('search-trending-reset');
      this.loadTrendingTopic();
    },
    async loadTrendingTopic() {
      this.loadDataSendTopicLatest();

      this.alert = false;
      this.loadingTagCloud = true;
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      try {
        const authToken = localStorage.getItem('token_app');
        if (!authToken) {
          throw new Error("Auth token not found");
        }
        this.selectedPeriode = this.$store.selectedPeriode_glob;
        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');

        const dataTagCloud = await axios.post(
          `td-topic-tag-cloud?period=${periode}&topic=${this.$store.topic_glob}&keyword=${this.$store.topic_glob2}&sentiment=${this.statusFilter}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        if (dataTagCloud && dataTagCloud.data && dataTagCloud.data.data) {
          if (this.isClickSentiment == false) {
            this.seriesDonut = [
              dataTagCloud.data.sentiment.neutral,
              dataTagCloud.data.sentiment.negative,
              dataTagCloud.data.sentiment.positive
            ]
          }
          if (this.isClickSentiment == true) {
            if (this.statusFilter == "Neutral") {
              this.seriesDonut = [dataTagCloud.data.sentiment.neutral, 0, 0]
            }
            if (this.statusFilter == "Negative") {
              this.seriesDonut = [0, dataTagCloud.data.sentiment.negative, 0]
            }
            if (this.statusFilter == "Positive") {
              this.seriesDonut = [0, 0, dataTagCloud.data.sentiment.positive]
            }
            window.dispatchEvent(new Event("resize"));
          }

          if (this.isClickSentiment == false) {
            const countAll = dataTagCloud.data.sentiment.negative + dataTagCloud.data.sentiment.neutral + dataTagCloud.data.sentiment.positive;
            const beritaNegativePersen = dataTagCloud.data.sentiment.negative / countAll * 100;
            this.beritaNegativePersen = parseFloat(beritaNegativePersen.toFixed(2));
            this.beritaNegative = dataTagCloud.data.sentiment.negative;

            const beritaNetralPersen = dataTagCloud.data.sentiment.neutral / countAll * 100;
            this.beritaNetralPersen = parseFloat(beritaNetralPersen.toFixed(2));
            this.beritaNetral = dataTagCloud.data.sentiment.neutral;

            const beritaPositivePersen = dataTagCloud.data.sentiment.positive / countAll * 100;
            this.beritaPositivePersen = parseFloat(beritaPositivePersen.toFixed(2));
            this.beritaPositive = dataTagCloud.data.sentiment.positive;
            if (isNaN(beritaPositivePersen)) {
              this.beritaPositivePersen = 0;
            }
            if (isNaN(beritaNetralPersen)) {
              this.beritaNetralPersen = 0;
            }
            if (isNaN(beritaNegativePersen)) {
              this.beritaNegativePersen = 0;
            }
          }
          if (this.isClickSentiment == true) {
            if (this.statusFilter == "Positive") {
              this.beritaPositivePersen = 100;
              this.beritaNetralPersen = 0;
              this.beritaNetral = 0;
              this.beritaNegativePersen = 0;
              this.beritaNegative = 0;
            }
            if (this.statusFilter == "Neutral") {
              this.beritaNetralPersen = 100;
              this.beritaPositivePersen = 0;
              this.beritaPositive = 0;
              this.beritaNegativePersen = 0;
              this.beritaNegative = 0;
            }
            if (this.statusFilter == "Negative") {
              this.beritaNegativePersen = 100;
              this.beritaPositivePersen = 0;
              this.beritaPositive = 0;
              this.beritaNetralPersen = 0;
              this.beritaNetral = 0;
            }
          }

          let maxSentiment = Math.max(this.beritaPositive, this.beritaNetral, this.beritaNegative);
          if (maxSentiment == this.beritaPositive) {
            this.selectedTab = 0;
            this.tabsSentiment = "Positive";
          } else if (maxSentiment == this.beritaNetral) {
            this.selectedTab = 1;
            this.tabsSentiment = "Neutral";
          } else {
            this.selectedTab = 2;
            this.tabsSentiment = "Negative";
          }

          this.wordsNewsInitial = [];
          this.wordsNews = [];
          const dataNews = Array.isArray(dataTagCloud.data.data.tag_cloud_news) && dataTagCloud.data.data.tag_cloud_news.length > 0
          ? dataTagCloud.data.data.tag_cloud_news : {};
          if (Object.keys(dataNews).length > 0) {
            const resultNews = dataNews.map(item => ({
              name: item.keyword,
              value: item.count,
              source: item.source
            }));
            resultNews.sort(function (a, b) {
              return (b.value) - (a.value);
            });
            const totalCountNews = resultNews.reduce((sum, item) => sum + item.value, 0);
            resultNews.forEach(item => {
              item.percentage = totalCountNews > 0 ? parseFloat(((item.value / totalCountNews) * 100).toFixed(2)) : 0;
            });
            this.wordsNewsInitial = resultNews.slice(0, 100);
            this.wordsNews = resultNews.slice(0, 100);
            this.colorWordCloudNews = Array(this.wordsNews.length).fill("#0471A5");
          }

          this.wordsSocialMediaInitial = [];
          this.wordsSocialMedia = [];
          const dataSocmed = Array.isArray(dataTagCloud.data.data.tag_cloud_socmed) && dataTagCloud.data.data.tag_cloud_socmed.length > 0
          ? dataTagCloud.data.data.tag_cloud_socmed : {};
          if (Object.keys(dataSocmed).length > 0) {
            const resultSocmed = dataSocmed.map(item => ({
              name: item.keyword,
              value: item.count,
              source: item.source
            }));
            resultSocmed.sort(function (a, b) {
              return (b.value) - (a.value);
            });
            const totalCountSocmed = resultSocmed.reduce((sum, item) => sum + item.value, 0);
            resultSocmed.forEach(item => {
              item.percentage = totalCountSocmed > 0 ? parseFloat(((item.value / totalCountSocmed) * 100).toFixed(2)) : 0;
            });
            this.wordsSocialMediaInitial = resultSocmed.slice(0, 100);
            this.wordsSocialMedia = resultSocmed.slice(0, 100);
            this.colorWordCloudSocialMedia = Array(this.wordsSocialMedia.length).fill("#0471A5");
          }

          if (this.wordsNews.length == 1) {
            this.fontSizeTagCloudNews = [30, 30];
          }

          if (this.wordsSocialMedia.length == 1) {
            this.fontSizeTagCloudSocialMedia = [30, 30];
          }

          this.nerPersonInitial = [];
          this.nerOrganizationInitial = [];
          this.nerPersonInitial.push(dataTagCloud.data.ner_person);
          this.nerOrganizationInitial.push(dataTagCloud.data.ner_organization);
          let nerPerson = dataTagCloud.data.ner_person;
          let nerOrganization = dataTagCloud.data.ner_organization;

          this.seriesBarPerson[0].data = [];
          this.barChartPerson.xaxis.categories = [];
          let categories = [];
          if (nerPerson.length > 0) {
            nerPerson.sort((a, b) => b.count - a.count);

            nerPerson.forEach((val,key) => {
              if (key < 10) {
                const shortLabel = val.person.length > 10
                    ? val.person.substring(0, 10) + '…'
                    : val.person;

                const domainList = (val.domains || '')
                  .split(',')
                  .map(d => d.trim())
                  .filter(d => d != '');

                const domainsCount = [...new Set(domainList)].length;

                const socmedDomains = ['twitter.com', 'youtube.com', 'tiktok.com', 'instagram.com'];
                const socmedSet = new Set();

                (val.url || []).forEach(item => {
                  if (item.url) {
                    try {
                      const urlObj = new URL(item.url);
                      const hostname = urlObj.hostname.replace('www.', '').toLowerCase();
                      socmedDomains.forEach(domain => {
                        if (hostname.includes(domain)) {
                          socmedSet.add(domain);
                        }
                      });
                    } catch (e) {
                      console.log(e)
                    }
                  }
                });

                const socmedCount = socmedSet.size;

                this.seriesBarPerson[0].data.push({
                  x: shortLabel,
                  y: val.count,
                  fullName: val.person,
                  count: val.count,
                  domainsCount: domainsCount,
                  socmedCount: socmedCount,
                  sentiment: {
                    positive: val.positive,
                    negative: val.negative,
                    neutral: val.neutral
                  }
                });
                categories.push(shortLabel);
              }
            });
          }

          this.barChartPerson = {
            xaxis: {
              categories: categories
            }
          };

          this.seriesBarOrganization[0].data = [];
          this.barChartOrganization.xaxis.categories = [];
          let categoriesOrganization = [];

          if (nerOrganization.length > 0) {
            nerOrganization.sort((a, b) => b.count - a.count);
            nerOrganization.forEach((val,key) => {
              if (key < 10) {
                const shortLabel = val.organization.length > 10
                    ? val.organization.substring(0, 10) + '…'
                    : val.organization;

                const domainList = (val.domains || '')
                  .split(',')
                  .map(d => d.trim())
                  .filter(d => d != '');

                const domainsCount = [...new Set(domainList)].length;

                const socmedDomains = ['twitter.com', 'youtube.com', 'tiktok.com', 'instagram.com'];
                const socmedSet = new Set();

                (val.url || []).forEach(item => {
                  if (item.url) {
                    try {
                      const urlObj = new URL(item.url);
                      const hostname = urlObj.hostname.replace('www.', '').toLowerCase();
                      socmedDomains.forEach(domain => {
                        if (hostname.includes(domain)) {
                          socmedSet.add(domain);
                        }
                      });
                    } catch (e) {
                      console.log(e)
                    }
                  }
                });

                const socmedCount = socmedSet.size;

                this.seriesBarOrganization[0].data.push({
                  x: shortLabel,
                  y: val.count,
                  fullName: val.organization,
                  count: val.count,
                  domainsCount: domainsCount,
                  socmedCount: socmedCount,
                  sentiment: {
                    positive: val.positive,
                    negative: val.negative,
                    neutral: val.neutral
                  }
                });
                categoriesOrganization.push(shortLabel);
              }
            });
          }

          this.barChartOrganization = {
            xaxis: {
              categories: categoriesOrganization
            }
          };

          let urlContent = dataTagCloud.data.url_content;

          this.kontenBeritaAll = {
            positive: [],
            negative: [],
            neutral: [],
            all: []
          };

          this.kontenBeritaAllInitial = {
            positive: [],
            negative: [],
            neutral: [],
            all: []
          };

          this.kontenBeritaNegative = [];
          this.kontenBeritaPositive = [];
          this.kontenBeritaNetral = [];

          urlContent.forEach((val) => {
            this.kontenBeritaAll.all.push(val);
            if (val.sentiment && typeof val.sentiment === 'string' && val.sentiment.toUpperCase() == "POSITIVE") {
              if (this.statusFilter.toUpperCase() == "POSITIVE" || this.statusFilter.toUpperCase() == "") {
                this.pageUrlkontenBeritaPositive.push(val);
                this.kontenBeritaAll.positive.push(val);
                this.kontenBeritaAllInitial.positive.push(val);
              }
            } else if (val.sentiment && typeof val.sentiment === 'string' && val.sentiment.toUpperCase() == "NEGATIVE") {
              if (this.statusFilter.toUpperCase() == "NEGATIVE" || this.statusFilter.toUpperCase() == "") {
                this.pageUrlkontenBeritaNegative.push(val);
                this.kontenBeritaAll.negative.push(val);
                this.kontenBeritaAllInitial.negative.push(val);
              }
            } else {
              if (this.statusFilter.toUpperCase() == "NEUTRAL" || this.statusFilter.toUpperCase() == "") {
                this.pageUrlkontenBeritaNetral.push(val);
                this.kontenBeritaAll.neutral.push(val);
                this.kontenBeritaAllInitial.neutral.push(val);
              }
            }
          });

          this.pageLengthPositive = Math.ceil(this.kontenBeritaAll.positive.length / this.itemsPerPage);
          this.pageLengthNetral = Math.ceil(this.kontenBeritaAll.neutral.length / this.itemsPerPage);
          this.pageLengthNegative = Math.ceil(this.kontenBeritaAll.negative.length / this.itemsPerPage);
        }

        if (this.seriesDonut.every(element => element == 0)) {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API td-topic-tag-cloud Response Data Not Found";
          this.colorAlert = "red";
        }

        window.dispatchEvent(new Event("resize"));
        this.setFirstPageBySentiment();
        this.loadingTagCloud = false;
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      } catch(e) {
        console.log(e);
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API td-topic-tag-cloud Response Data Not Found";
        this.colorAlert = "red";
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      }

      if (this.isSearch == true) {
        this.openDialogSearchContext();
      }

      this.isSearch = false;
    },
    async loadSearchTrendingTopic() {
      this.fontSizeTagCloudNews = [10, 30];
      this.fontSizeTagCloudSocialMedia = [10, 30];

      this.filterReset();

      for (let i = 0; i < this.topicSentiment.length; i++) {
        if (this.topicSentiment[i].SEQ_ID == this.$store.topic_glob) {
          this.searchContextTopic = this.topicSentiment[i].TOPIC;
        }
      }

      this.listIndexOpenInsight.push(true);

      trackEvent('trending-topic-search', {topic: this.searchContextTopic, period: this.selectedPeriode, keyword: this.selectedKeyword});
    },
    async loadDataSendTopicLatest() {
      try {
        const authToken = localStorage.getItem('token_app');
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        let periode = this.$store.selectedPeriode_glob.toUpperCase().replace(/ /g, '_');
        const topic = this.$store.topic_glob;

        const endpoints = ['SCHEDULER TAG CLOUDE', 'TAG CLOUDE'];

        const results = [];

        for (const endpoint of endpoints) {
          const response = await axios.get(
            `data-send-topic-last-calculated?periode=${periode}&topic=${topic}&endpoint=${endpoint}`,
            {
              headers: {
                'auth-token': authToken,
              },
            }
          );

          const result = response?.data?.data?.result;

          if (Array.isArray(result) && result.length > 0 && result[0].CREATED_AT) {
            results.push(result[0]);
          }
        }

        if (results.length > 0) {
          const latest = results.reduce((a, b) => a.SEQ_ID > b.SEQ_ID ? a : b);
          this.lastCalculatedOn = this.formatDateReadable(latest.CREATED_AT);
        } else {
          this.lastCalculatedOn = '-';
        }
      } catch (error) {
        this.lastCalculatedOn = '-';
      }
    },
    formatDateReadable(dateString) {
      const [datePart, timePart] = dateString.split(' ');
      const [day, month, year] = datePart.split('-');

      const monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr',
        'May', 'Jun', 'Jul', 'Aug',
        'Sep', 'Oct', 'Nov', 'Dec'
      ];

      const monthName = monthNames[parseInt(month) - 1];

      return `${day} ${monthName} ${year}, ${timePart}`;
    },
    filterBySentiment(event, chartContext, config) {
      const index = config.dataPointIndex;

      if (
        (index == 0 && this.statusFilter == "Neutral") ||
        (index == 1 && this.statusFilter == "Negative") ||
        (index == 2 && this.statusFilter == "Positive")
      ) {
        this.isClickSentiment = false;
        this.statusFilter = "";
        this.$store.commit("addButtonTmp", {
          sentiment_glob: "",
        });
        this.loadTrendingTopic();
      } else {
        this.isClickSentiment = true;
        if (index == 0) {
          this.statusFilter = "Neutral";
          this.tabsSentiment = 'Neutral';
          this.loadTrendingTopic();
        }
        if (index == 1) {
          this.statusFilter = "Negative";
          this.tabsSentiment = 'Negative';
          this.loadTrendingTopic();
        }
        if (index == 2) {
          this.statusFilter = "Positive";
          this.tabsSentiment = 'Positive';
          this.loadTrendingTopic();
        }
      }
      window.dispatchEvent(new Event("resize"));
    },
    wordClickHandlerNews(name) {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      this.colorWordCloudSocialMedia = Array(this.wordsNews.length).fill("#0471A5");
      this.wordCloudKeySocialMedia += 1;

      const index = this.wordsNews.findIndex(item => item.name == name);

      this.colorWordCloudNews = this.wordsNews.map((_, i) =>
        i == index ? "#0471A5" : "#808080"
      );

      this.colorWordCloudSocialMedia = Array(this.wordsSocialMedia.length).fill("#808080");

      if (this.selectedWordDetail.text == name) {
        this.selectedWordDetail = "";
        this.colorWordCloudNews = Array(this.wordsNews.length).fill("#0471A5");
      }

      this.hideTooltip();
      this.wordCloudKeyNews += 1;

      const dataByrows = this.wordsNews.find(item => item.name == name);
      if (dataByrows) {
        this.selectedWordDetail = dataByrows;
      } else {
        console.warn("Data tidak ditemukan untuk kata:", name);
      }

      if (this.colorWordCloudNews.every(color => color == '#0471A5')) {
        this.selectedWordDetail = "";
      }

      if (this.selectedWordDetail != "") {
        this.seriesBarPerson[0].data = "";
        this.seriesBarPerson[0].data = [];
        this.barChartPerson.xaxis.categories = "";
        this.barChartPerson.xaxis.categories = [];
        let categories = [];

        const nerPerson = [];
        this.nerPersonInitial[0].forEach((val) => {
          if (val.source == "NEWS") {
            const keywordsArray = val.keywords
              .split(',')
              .map(k => k.trim().toUpperCase());
            if (keywordsArray.includes(name.toUpperCase())) {
              nerPerson.push(val);
            }
          }
        });

        if (nerPerson.length > 0) {
          nerPerson.sort((a, b) => b.count - a.count);

          nerPerson.forEach((val, key) => {
            if (key < 10) {
              const shortLabel = val.person.length > 10
                ? val.person.substring(0, 10) + '…'
                : val.person;

              const domainList = (val.domains || '')
                .split(',')
                .map(d => d.trim())
                .filter(d => d != '');

              const domainsCount = [...new Set(domainList)].length;

              const socmedDomains = ['twitter.com', 'youtube.com', 'tiktok.com', 'instagram.com'];
              const socmedSet = new Set();

              (val.url || []).forEach(item => {
                if (item.url) {
                  try {
                    const urlObj = new URL(item.url);
                    const hostname = urlObj.hostname.replace('www.', '').toLowerCase();
                    socmedDomains.forEach(domain => {
                      if (hostname.includes(domain)) {
                        socmedSet.add(domain);
                      }
                    });
                  } catch (e) {
                    console.log(e)
                  }
                }
              });

              const socmedCount = socmedSet.size;

              this.seriesBarPerson[0].data.push({
                x: shortLabel,
                y: val.count,
                fullName: val.person,
                count: val.count,
                domainsCount: domainsCount,
                socmedCount: socmedCount,
                sentiment: {
                  positive: val.positive,
                  negative: val.negative,
                  neutral: val.neutral
                }
              });
              categories.push(shortLabel);
            }
          });
        }

        this.barChartPerson = {
          xaxis: {
            categories: categories
          }
        };

        this.seriesBarOrganization[0].data = [];
        this.barChartOrganization.xaxis.categories = [];
        let categoriesOrganization = [];

        if (this.nerOrganizationInitial[0].length > 0) {
          this.nerOrganizationInitial[0].sort((a, b) => b.count - a.count);
          this.nerOrganizationInitial[0].forEach((val, key) => {
            if (key < 10) {
              const shortLabel = val.organization.length > 10
                  ? val.organization.substring(0, 10) + '…'
                  : val.organization;

              const domainList = (val.domains || '')
                .split(',')
                .map(d => d.trim())
                .filter(d => d != '');
              const domainsCount = [...new Set(domainList)].length;

              const socmedDomains = ['twitter.com', 'youtube.com', 'tiktok.com', 'instagram.com'];
              const socmedSet = new Set();

              (val.url || []).forEach(item => {
                if (item.url) {
                  try {
                    const urlObj = new URL(item.url);
                    const hostname = urlObj.hostname.replace('www.', '').toLowerCase();
                    socmedDomains.forEach(domain => {
                      if (hostname.includes(domain)) {
                        socmedSet.add(domain);
                      }
                    });
                  } catch (e) {
                    console.log(e)
                  }
                }
              });

              const socmedCount = socmedSet.size;

              this.seriesBarOrganization[0].data.push({
                x: shortLabel,
                y: val.count,
                fullName: val.organization,
                count: val.count,
                domainsCount: domainsCount,
                socmedCount: socmedCount,
                sentiment: {
                  positive: val.positive,
                  negative: val.negative,
                  neutral: val.neutral
                }
              });
              categoriesOrganization.push(shortLabel);
            }
          });
        }

        this.barChartOrganization = {
          xaxis: {
            categories: categoriesOrganization
          }
        };

        let tmpNegative = [];
        let tmpPositive = [];
        let tmpNeutral = [];

        const sourceIds = new Set(
          dataByrows.source
            .map(item => item.id)
            .filter(id => id)
        );

        const filterById = (arr) => {
          const seen = new Set();
          return arr.filter(item => {
            if (!sourceIds.has(item.id)) return false;
            if (seen.has(item.id)) return false;
            seen.add(item.id);
            return true;
          });
        };

        tmpNegative = filterById(this.kontenBeritaAllInitial.negative);
        tmpPositive = filterById(this.kontenBeritaAllInitial.positive);
        tmpNeutral = filterById(this.kontenBeritaAllInitial.neutral);

        const countAll = tmpNegative.length + tmpNeutral.length + tmpPositive.length;
        const beritaNegativePersen = tmpNegative.length / countAll * 100;
        this.beritaNegativePersen = parseFloat(beritaNegativePersen.toFixed(2));
        this.beritaNegative = tmpNegative.length;

        const beritaNetralPersen = tmpNeutral.length / countAll * 100;
        this.beritaNetralPersen = parseFloat(beritaNetralPersen.toFixed(2));
        this.beritaNetral = tmpNeutral.length;

        const beritaPositivePersen = tmpPositive.length / countAll * 100;
        this.beritaPositivePersen = parseFloat(beritaPositivePersen.toFixed(2));
        this.beritaPositive = tmpPositive.length;

        if (isNaN(beritaPositivePersen)) {
          this.beritaPositivePersen = 0;
        }
        if (isNaN(beritaNetralPersen)) {
          this.beritaNetralPersen = 0;
        }
        if (isNaN(beritaNegativePersen)) {
          this.beritaNegativePersen = 0;
        }

        let maxSentiment = Math.max(this.beritaPositive, this.beritaNetral, this.beritaNegative);
        if (maxSentiment == this.beritaPositive) {
          this.selectedTab = 0;
          this.tabsSentiment = "Positive";
        } else if (maxSentiment == this.beritaNetral) {
          this.selectedTab = 1;
          this.tabsSentiment = "Neutral";
        } else {
          this.selectedTab = 2;
          this.tabsSentiment = "Negative";
        }

        this.kontenBeritaAll = {
          positive: [],
          negative: [],
          neutral: [],
          all: []
        };

        this.kontenBeritaAll.positive = (tmpPositive);
        this.kontenBeritaAll.neutral = (tmpNeutral);
        this.kontenBeritaAll.negative = (tmpNegative);
        this.kontenBeritaNegative = [];
        this.kontenBeritaPositive = [];
        this.kontenBeritaNetral = [];
        this.kontenBeritaPositive = (tmpPositive);
        this.kontenBeritaNetral = (tmpNeutral);
        this.kontenBeritaNegative = (tmpNegative);
        this.pageLengthPositive = Math.ceil(this.kontenBeritaPositive.length / this.itemsPerPage);
        this.pageLengthNetral = Math.ceil(this.kontenBeritaNetral.length / this.itemsPerPage);
        this.pageLengthNegative = Math.ceil(this.kontenBeritaNegative.length / this.itemsPerPage);
        this.contentListSentiment(this.tabsSentiment);
      } else {
        this.loadTrendingTopic();
      }

      window.dispatchEvent(new Event("resize"));
      setTimeout(() => {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      }, 1000);
    },
    wordClickHandlerSocmed(name) {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      this.colorWordCloudNews = Array(this.wordsNews.length).fill("#0471A5");
      this.wordCloudKeyNews += 1;

      const index = this.wordsSocialMedia.findIndex(item => item.name == name);

      this.colorWordCloudSocialMedia = this.wordsSocialMedia.map((_, i) =>
        i == index ? "#0471A5" : "#808080"
      );

      this.colorWordCloudNews = Array(this.wordsNews.length).fill("#808080");

      if (this.selectedWordDetail.text == name) {
        this.selectedWordDetail = "";
        this.colorWordCloudSocialMedia = Array(this.wordsSocialMedia.length).fill("#0471A5");
      }

      this.hideTooltip();
      this.wordCloudKeySocialMedia += 1;

      const dataByrows = this.wordsSocialMedia.find(item => item.name == name);
      if (dataByrows) {
        this.selectedWordDetail = dataByrows;
      } else {
        console.warn("Data tidak ditemukan untuk kata:", name);
      }

      if (this.colorWordCloudSocialMedia.every(color => color == '#0471A5')) {
        this.selectedWordDetail = "";
      }

      if (this.selectedWordDetail != "") {
        this.seriesBarPerson[0].data = [];
        this.barChartPerson = {
          ...this.barChartPerson,
          xaxis: {
            ...this.barChartPerson.xaxis,
            categories: []
          }
        }

        const nerPerson = [];
        this.nerPersonInitial[0].forEach((val) => {
          if (val.source == "SOCMED") {
            const keywordsArray = val.keywords
              .split(',')
              .map(k => k.trim().toUpperCase());
            if (keywordsArray.includes(name.toUpperCase())) {
              nerPerson.push(val);
            }
          }
        });

        if (nerPerson.length > 0) {
          nerPerson.sort((a, b) => b.count - a.count);

          nerPerson.forEach((val, key) => {
            if (key < 10) {
              const shortLabel = val.person.length > 10
                ? val.person.substring(0, 10) + '…'
                : val.person;

              const domainList = (val.domains || '')
                .split(',')
                .map(d => d.trim())
                .filter(d => d != '');

              const domainsCount = [...new Set(domainList)].length;

              const socmedDomains = ['twitter.com', 'youtube.com', 'tiktok.com', 'instagram.com'];
              const socmedSet = new Set();

              (val.url || []).forEach(item => {
                if (item.url) {
                  try {
                    const urlObj = new URL(item.url);
                    const hostname = urlObj.hostname.replace('www.', '').toLowerCase();
                    socmedDomains.forEach(domain => {
                      if (hostname.includes(domain)) {
                        socmedSet.add(domain);
                      }
                    });
                  } catch (e) {
                    console.log(e)
                  }
                }
              });

              const socmedCount = socmedSet.size;

              this.seriesBarPerson[0].data.push({
                x: shortLabel,
                y: val.count,
                fullName: val.person,
                count: val.count,
                domainsCount: domainsCount,
                socmedCount: socmedCount,
                sentiment: {
                  positive: val.positive,
                  negative: val.negative,
                  neutral: val.neutral
                }
              });
              this.barChartPerson.xaxis.categories.push(shortLabel);
            }
          });
        }

        this.seriesBarOrganization[0].data = [];
        this.barChartOrganization = {
          ...this.barChartOrganization,
          xaxis: {
            ...this.barChartOrganization.xaxis,
            categories: []
          }
        };

        if (this.nerOrganizationInitial[0].length > 0) {
          this.nerOrganizationInitial[0].sort((a, b) => b.count - a.count);
          this.nerOrganizationInitial[0].forEach((val, key) => {
            if (key < 10) {
              const shortLabel = val.organization.length > 10
                  ? val.organization.substring(0, 10) + '…'
                  : val.organization;

              const domainList = (val.domains || '')
                .split(',')
                .map(d => d.trim())
                .filter(d => d != '');
              const domainsCount = [...new Set(domainList)].length;

              const socmedDomains = ['twitter.com', 'youtube.com', 'tiktok.com', 'instagram.com'];
              const socmedSet = new Set();

              (val.url || []).forEach(item => {
                if (item.url) {
                  try {
                    const urlObj = new URL(item.url);
                    const hostname = urlObj.hostname.replace('www.', '').toLowerCase();
                    socmedDomains.forEach(domain => {
                      if (hostname.includes(domain)) {
                        socmedSet.add(domain);
                      }
                    });
                  } catch (e) {
                    console.log(e)
                  }
                }
              });

              const socmedCount = socmedSet.size;

              this.seriesBarOrganization[0].data.push({
                x: shortLabel,
                y: val.count,
                fullName: val.organization,
                count: val.count,
                domainsCount: domainsCount,
                socmedCount: socmedCount,
                sentiment: {
                  positive: val.positive,
                  negative: val.negative,
                  neutral: val.neutral
                }
              });

              this.barChartOrganization.xaxis.categories[key] = shortLabel;
            }
          });
        }

        let tmpNegative = [];
        let tmpPositive = [];
        let tmpNeutral = [];

        const sourceIds = new Set(
          dataByrows.source
            .map(item => item.id)
            .filter(id => id)
        );

        const filterById = (arr) => {
          const seen = new Set();
          return arr.filter(item => {
            if (!sourceIds.has(item.id)) return false;
            if (seen.has(item.id)) return false;
            seen.add(item.id);
            return true;
          });
        };

        tmpNegative = filterById(this.kontenBeritaAllInitial.negative);
        tmpPositive = filterById(this.kontenBeritaAllInitial.positive);
        tmpNeutral = filterById(this.kontenBeritaAllInitial.neutral);

        const countAll = tmpNegative.length + tmpNeutral.length + tmpPositive.length;
        const beritaNegativePersen = tmpNegative.length / countAll * 100;
        this.beritaNegativePersen = parseFloat(beritaNegativePersen.toFixed(2));
        this.beritaNegative = tmpNegative.length;

        const beritaNetralPersen = tmpNeutral.length / countAll * 100;
        this.beritaNetralPersen = parseFloat(beritaNetralPersen.toFixed(2));
        this.beritaNetral = tmpNeutral.length;

        const beritaPositivePersen = tmpPositive.length / countAll * 100;
        this.beritaPositivePersen = parseFloat(beritaPositivePersen.toFixed(2));
        this.beritaPositive = tmpPositive.length;

        if (isNaN(beritaPositivePersen)) {
          this.beritaPositivePersen = 0;
        }
        if (isNaN(beritaNetralPersen)) {
          this.beritaNetralPersen = 0;
        }
        if (isNaN(beritaNegativePersen)) {
          this.beritaNegativePersen = 0;
        }

        let maxSentiment = Math.max(this.beritaPositive, this.beritaNetral, this.beritaNegative);
        if (maxSentiment == this.beritaPositive) {
          this.selectedTab = 0;
          this.tabsSentiment = "Positive";
        } else if (maxSentiment == this.beritaNetral) {
          this.selectedTab = 1;
          this.tabsSentiment = "Neutral";
        } else {
          this.selectedTab = 2;
          this.tabsSentiment = "Negative";
        }

        this.kontenBeritaAll = {
          positive: [],
          negative: [],
          neutral: [],
          all: []
        };

        this.kontenBeritaAll.positive = (tmpPositive);
        this.kontenBeritaAll.neutral = (tmpNeutral);
        this.kontenBeritaAll.negative = (tmpNegative);
        this.kontenBeritaNegative = [];
        this.kontenBeritaPositive = [];
        this.kontenBeritaNetral = [];
        this.kontenBeritaPositive = (tmpPositive);
        this.kontenBeritaNetral = (tmpNeutral);
        this.kontenBeritaNegative = (tmpNegative);
        this.pageLengthPositive = Math.ceil(this.kontenBeritaPositive.length / this.itemsPerPage);
        this.pageLengthNetral = Math.ceil(this.kontenBeritaNetral.length / this.itemsPerPage);
        this.pageLengthNegative = Math.ceil(this.kontenBeritaNegative.length / this.itemsPerPage);
        this.contentListSentiment(this.tabsSentiment);
      } else {
        this.loadTrendingTopic();
      }

      window.dispatchEvent(new Event("resize"));
      setTimeout(() => {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      }, 1000);
    },
    hideTooltip() {
      const tooltips = document.querySelectorAll('.tooltip, [role="tooltip"]');
      tooltips.forEach(tooltip => {
        tooltip.style.display = 'none';
        tooltip.remove();
      });
    },
    clickChartBarPerson(event, chartContext, config) {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      const dataPointIndex = config.dataPointIndex;
      const seriesIndex = config.seriesIndex;
      const label = this.seriesBarPerson[seriesIndex].data[dataPointIndex];

      var dataPerson = "";
      this.nerPersonInitial[0].forEach((val) => {
        if (val.person == label.fullName) {
          dataPerson = val;
        }
      });

      let tmpNegative = [];
      let tmpPositive = [];
      let tmpNeutral = [];

      const idList = dataPerson.urlId
        .map(item => item.id)
        .filter(id => id);

      const getItemsByCount = (arr, count) => {
        if (!count) return [];

        const result = [];

        idList.forEach(id => {
          const found = arr.find(item => item.id == id);
          if (found) {
            result.push(found);
          }
        });

        return result;
      };

      tmpNegative = getItemsByCount(this.kontenBeritaAllInitial.negative, dataPerson.negative || 0);
      tmpPositive = getItemsByCount(this.kontenBeritaAllInitial.positive, dataPerson.positive || 0);
      tmpNeutral = getItemsByCount(this.kontenBeritaAllInitial.neutral, dataPerson.neutral || 0);

      const countAll = tmpNegative.length + tmpNeutral.length + tmpPositive.length;
      const beritaNegativePersen = tmpNegative.length / countAll * 100;
      this.beritaNegativePersen = parseFloat(beritaNegativePersen.toFixed(2));
      this.beritaNegative = tmpNegative.length;

      const beritaNetralPersen = tmpNeutral.length / countAll * 100;
      this.beritaNetralPersen = parseFloat(beritaNetralPersen.toFixed(2));
      this.beritaNetral = tmpNeutral.length;

      const beritaPositivePersen = tmpPositive.length / countAll * 100;
      this.beritaPositivePersen = parseFloat(beritaPositivePersen.toFixed(2));
      this.beritaPositive = tmpPositive.length;

      if (isNaN(beritaPositivePersen)) {
        this.beritaPositivePersen = 0;
      }
      if (isNaN(beritaNetralPersen)) {
        this.beritaNetralPersen = 0;
      }
      if (isNaN(beritaNegativePersen)) {
        this.beritaNegativePersen = 0;
      }

      let maxSentiment = Math.max(this.beritaPositive, this.beritaNetral, this.beritaNegative);
      if (maxSentiment == this.beritaPositive) {
        this.selectedTab = 0;
        this.tabsSentiment = "Positive";
      } else if (maxSentiment == this.beritaNetral) {
        this.selectedTab = 1;
        this.tabsSentiment = "Neutral";
      } else {
        this.selectedTab = 2;
        this.tabsSentiment = "Negative";
      }

      this.kontenBeritaAll = {
        positive: [],
        negative: [],
        neutral: [],
        all: []
      };
      this.kontenBeritaAll.positive = (tmpPositive);
      this.kontenBeritaAll.neutral = (tmpNeutral);
      this.kontenBeritaAll.negative = (tmpNegative);
      this.kontenBeritaNegative = [];
      this.kontenBeritaPositive = [];
      this.kontenBeritaNetral = [];
      this.kontenBeritaPositive = (tmpPositive);
      this.kontenBeritaNetral = (tmpNeutral);
      this.kontenBeritaNegative = (tmpNegative);
      this.pageLengthPositive = Math.ceil(this.kontenBeritaPositive.length / this.itemsPerPage);
      this.pageLengthNetral = Math.ceil(this.kontenBeritaNetral.length / this.itemsPerPage);
      this.pageLengthNegative = Math.ceil(this.kontenBeritaNegative.length / this.itemsPerPage);
      this.contentListSentiment(this.tabsSentiment);

      this.nerPersonSearch = this.barChartPerson.xaxis.categories[config.dataPointIndex];
      this.nerOrganizationSearch = "";

      setTimeout(() => {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      }, 1000);
    },
    clickChartBarOrganization(event, chartContext, config) {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      const dataPointIndex = config.dataPointIndex;
      const seriesIndex = config.seriesIndex;
      const label = this.seriesBarOrganization[seriesIndex].data[dataPointIndex];

      var dataOrganization = "";
      this.nerOrganizationInitial[0].forEach((val) => {
        if (val.organization == label.fullName) {
          dataOrganization = val;
        }
      });

      let tmpNegative = [];
      let tmpPositive = [];
      let tmpNeutral = [];

      const idList = dataOrganization.urlId
        .map(item => item.id)
        .filter(id => id);

      const getItemsByCount = (arr, count) => {
        if (!count) return [];

        const result = [];

        idList.forEach(id => {
          const found = arr.find(item => item.id == id);
          if (found) {
            result.push(found);
          }
        });

        return result;
      };

      tmpNegative = getItemsByCount(this.kontenBeritaAllInitial.negative, dataOrganization.negative || 0);
      tmpPositive = getItemsByCount(this.kontenBeritaAllInitial.positive, dataOrganization.positive || 0);
      tmpNeutral = getItemsByCount(this.kontenBeritaAllInitial.neutral, dataOrganization.neutral || 0);

      const countAll = tmpNegative.length + tmpNeutral.length + tmpPositive.length;
      const beritaNegativePersen = tmpNegative.length / countAll * 100;
      this.beritaNegativePersen = parseFloat(beritaNegativePersen.toFixed(2));
      this.beritaNegative = tmpNegative.length;

      const beritaNetralPersen = tmpNeutral.length / countAll * 100;
      this.beritaNetralPersen = parseFloat(beritaNetralPersen.toFixed(2));
      this.beritaNetral = tmpNeutral.length;

      const beritaPositivePersen = tmpPositive.length / countAll * 100;
      this.beritaPositivePersen = parseFloat(beritaPositivePersen.toFixed(2));
      this.beritaPositive = tmpPositive.length;

      if (isNaN(beritaPositivePersen)) {
        this.beritaPositivePersen = 0;
      }
      if (isNaN(beritaNetralPersen)) {
        this.beritaNetralPersen = 0;
      }
      if (isNaN(beritaNegativePersen)) {
        this.beritaNegativePersen = 0;
      }

      let maxSentiment = Math.max(this.beritaPositive, this.beritaNetral, this.beritaNegative);
      if (maxSentiment == this.beritaPositive) {
        this.selectedTab = 0;
        this.tabsSentiment = "Positive";
      } else if (maxSentiment == this.beritaNetral) {
        this.selectedTab = 1;
        this.tabsSentiment = "Neutral";
      } else {
        this.selectedTab = 2;
        this.tabsSentiment = "Negative";
      }

      this.kontenBeritaAll = {
        positive: [],
        negative: [],
        neutral: [],
        all: []
      };
      this.kontenBeritaAll.positive = (tmpPositive);
      this.kontenBeritaAll.neutral = (tmpNeutral);
      this.kontenBeritaAll.negative = (tmpNegative);
      this.kontenBeritaNegative = [];
      this.kontenBeritaPositive = [];
      this.kontenBeritaNetral = [];
      this.kontenBeritaPositive = (tmpPositive);
      this.kontenBeritaNetral = (tmpNeutral);
      this.kontenBeritaNegative = (tmpNegative);
      this.pageLengthPositive = Math.ceil(this.kontenBeritaPositive.length / this.itemsPerPage);
      this.pageLengthNetral = Math.ceil(this.kontenBeritaNetral.length / this.itemsPerPage);
      this.pageLengthNegative = Math.ceil(this.kontenBeritaNegative.length / this.itemsPerPage);
      this.contentListSentiment(this.tabsSentiment);

      this.nerOrganizationSearch = this.barChartOrganization.xaxis.categories[config.dataPointIndex];
      this.nerPersonSearch = "";

      setTimeout(() => {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      }, 1000);
    },
    contentListSentiment(sentiment) {
      this.tabsSentiment = sentiment;
      if (sentiment == 'Positive') {
        this.pagePositive = 1;
        this.handlePageChangePositive();
      } else if (sentiment == 'Neutral') {
        this.pageNetral = 1;
        this.handlePageChangeNetral();
      } else if (sentiment == 'Negative') {
        this.pageNegative = 1;
        this.handlePageChangeNegative();
      }
    },
    setFirstPageBySentiment() {
      if (this.tabsSentiment == 'Positive') {
        this.pagePositive = 1;
        this.handlePageChangePositive();
      } else if (this.tabsSentiment == 'Neutral') {
        this.pageNetral = 1;
        this.handlePageChangeNetral();
      } else if (this.tabsSentiment == 'Negative') {
        this.pageNegative = 1;
        this.handlePageChangeNegative();
      }
    },
    async handlePageChangePositive() {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;
      const start = (this.pagePositive - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      this.pageUrlkontenBeritaPositive = this.kontenBeritaAll.positive.slice(start, end);
      const authToken = localStorage.getItem('token_app');
      const dataContent = await axios.post(
        `td-topic-tag-cloud-detail`,
        {
          data_tagcloude: this.pageUrlkontenBeritaPositive,
        },
        {
          headers: {
            'auth-token': authToken,
          },
        }
      );
      this.kontenBeritaPositive = [];
      dataContent.data.content.forEach((val) => {
        this.kontenBeritaPositive.push(val);
      });
      this.overlayDialogLoading = false;
      this.dialogLoading = false;
    },
    async handlePageChangeNetral() {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;
      const start = Math.ceil((this.pageNetral - 1) * this.itemsPerPage);
      const end = start + this.itemsPerPage;
      this.pageUrlkontenBeritaNetral = this.kontenBeritaAll.neutral.slice(start, end);
      const authToken = localStorage.getItem('token_app');
      const dataContent = await axios.post(
        `td-topic-tag-cloud-detail`,
        {
          data_tagcloude: this.pageUrlkontenBeritaNetral,
        },
        {
          headers: {
            'auth-token': authToken,
          },
        }
      );
      this.kontenBeritaNetral = [];
      dataContent.data.content.forEach((val) => {
        this.kontenBeritaNetral.push(val);
      });
      this.overlayDialogLoading = false;
      this.dialogLoading = false;
    },
    async handlePageChangeNegative() {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;
      const start = (this.pageNegative - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      this.pageUrlkontenBeritaNegative = this.kontenBeritaAll.negative.slice(start, end);
      const authToken = localStorage.getItem('token_app');
      const dataContent = await axios.post(
        `td-topic-tag-cloud-detail`,
        {
          data_tagcloude: this.pageUrlkontenBeritaNegative,
        },
        {
          headers: {
            'auth-token': authToken,
          },
        }
      );
      this.kontenBeritaNegative = [];
      dataContent.data.content.forEach((val) => {
        this.kontenBeritaNegative.push(val);
      });
      this.overlayDialogLoading = false;
      this.dialogLoading = false;
    }
  }
}
</script>

<style scoped>
.rotate-animation {
  animation: rotateFrom90 1s linear;
}

@keyframes rotateFrom90 {
  from {
    transform: rotate(90deg);
  }
  to {
    transform: rotate(-450deg);
  }
}

.loading-dots {
  color: var(--color-theme);
  font-size: 32px;
  font-weight: bold;
  display: inline-flex;
}

.loading-dots span {
  animation: blink 1.5s infinite;
  margin: 0 2px;
}

.loading-dots span:nth-child(1) { animation-delay: 0s; }
.loading-dots span:nth-child(2) { animation-delay: 0.2s; }
.loading-dots span:nth-child(3) { animation-delay: 0.4s; }

@keyframes blink {
  0% { opacity: 0.2; }
  50% { opacity: 1; }
  100% { opacity: 0.2; }
}

.response-textdescribedashboard {
  background: #f4f4f4;
  color: #2e2e2e;
  overflow-x: auto;
  display: block;
  white-space: pre-wrap;
  max-width: 100%;
  max-height: 100%;
  padding: 10px;
  border-radius: 8px;
  line-height: 1.6;
}

.response-textdescribedashboard strong {
  display: block;
  margin-bottom: 4px;
}

.response-textdescribedashboard ul {
  margin-top: 4px;
  padding-left: 20px;
}

.btn-close-dialog-search-context {
  position: absolute;
  top: 5px;
  right: 5px;
  color: white;
  margin-left: auto;
}

.confirm-reset {
  position: absolute; top: 10px; right: 10px;
}

.chart-wrapper {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

@media (max-width: 1264px) {
  .chart-wrapper {
    justify-content: center;
  }
}

::v-deep .apexcharts-pie-area {
  opacity: 1;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

::v-deep .apexcharts-slices:hover .apexcharts-pie-area:not(:hover) {
  opacity: 0.3 !important;
  transition: opacity 0.3s ease;
}

::v-deep .apexcharts-slices .apexcharts-pie-area:hover {
  opacity: 1 !important;
  transition: opacity 0.3s ease;
  filter: brightness(1.15) drop-shadow(0 0 8px rgba(0,0,0,0.2));
}

::v-deep .apexcharts-datalabels,
::v-deep .apexcharts-datalabel,
::v-deep .apexcharts-datalabel-label,
::v-deep .apexcharts-datalabel-value {
  opacity: 1 !important;
  pointer-events: none;
}

.class-title {
  padding-top: 32px;
  padding-left: 30px;
}

.wordcloud-class {
  min-width: 150px !important;
  max-height: 300px !important;
  margin-top: -8px !important;
  display: flex;
  align-items: flex-start;
}

.wordcloud-class >>> text {
  cursor: pointer;
}

.overflow-card {
  overflow-y: auto;
  overflow-x: hidden;
}

.content-list-card {
  border-radius: 8px;
  border: 0.6px solid #E4E4E4;
  background: #FFF;
}

.content-list-card:hover {
  border-radius: 8px;
  border: 0.6px solid #E4E4E4;
  background: #FFF;
  box-shadow: 3px 5px 7px 0px #E4E4E4 !important;
}

.v-avatar.color-avatar-berita-online {
  background-image:
  linear-gradient(to right top, #53d166, #5dd468, #65d769, #6eda6b, #76dd6d, #7ee06f, #86e271, #8de573, #96e876, #9fec79, #a8ef7c, #b1f27f);
}

.v-avatar.color-avatar-x-tik-tok {
  background-image: linear-gradient(to right top, #000000, #000000) !important;
}

.v-avatar.color-avatar-ytb {
  background-image:
  linear-gradient(to right top, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000) !important;
}

.v-avatar.color-avatar-ig {
  background-image:
  linear-gradient(to right top, #f09433, #e6683c, #dc2743, #cc2366, #bc1888, #cb33b4, #d844ee, #ffdc80);
}
</style>

<style>
.wordcloud-class div.tooltip,
.wordcloud-class ~ div.tooltip,
div.tooltip:not(.v-tooltip__content) {
  background: #ffffff !important;
  background-color: #ffffff !important;
  color: #000000 !important;
  font: 16px Arial !important;
  pointer-events: none;
  height: auto !important;
  min-width: 150px !important;
  padding: 8px !important;
  line-height: 18px !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
  border: 1px solid #e0e0e0 !important;
}

.wordcloud-class .tooltip .tooltip-inner,
div.tooltip:not(.v-tooltip__content) .tooltip-inner {
  background: #ffffff !important;
  background-color: #ffffff !important;
  color: #000000 !important;
  width: 100px !important;
  max-width: 100px !important;
}
</style>
